/**
 * #common_msg.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { Any } from "../../../../google/protobuf/any.js";
import { ListValue } from "../../../../google/protobuf/struct.js";
import { BoolValue, Int32Value, Int64Value, StringValue } from "../../../../google/protobuf/wrappers.js";
import { scopeFromJSON, scopeToJSON } from "../../../../reddit/devvit/app_permission/v1/app_permission.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { User } from "../../../reddit/user.js";
/**
 * Label that can be applied to a highlighted post in a subreddit.
 * This enum should map to the equivalent in GraphQL: https://github.snooguts.net/reddit/reddit-service-graphql/blob/master/graphql-py/graphql_api/lib/community_eng/types/highlighted_post.py#L18
 */
export var HighlightedPostLabel;
(function (HighlightedPostLabel) {
    /** HIGHLIGHTED_POST_LABEL_UNSPECIFIED - Post is highlighted without a label. */
    HighlightedPostLabel[HighlightedPostLabel["HIGHLIGHTED_POST_LABEL_UNSPECIFIED"] = 0] = "HIGHLIGHTED_POST_LABEL_UNSPECIFIED";
    /** ANNOUNCEMENT - Post is highlighted as an announcement. */
    HighlightedPostLabel[HighlightedPostLabel["ANNOUNCEMENT"] = 1] = "ANNOUNCEMENT";
    /** EVENT - Post is highlighted as an event. */
    HighlightedPostLabel[HighlightedPostLabel["EVENT"] = 2] = "EVENT";
    /** MEGATHREAD - Post is highlighted as a megathread. */
    HighlightedPostLabel[HighlightedPostLabel["MEGATHREAD"] = 3] = "MEGATHREAD";
    /**
     * SHOW_POST_FLAIR - Post is highlighted with its flair as the label.
     * If the post doesn't have flair, this is the same as UNSPECIFIED
     */
    HighlightedPostLabel[HighlightedPostLabel["SHOW_POST_FLAIR"] = 4] = "SHOW_POST_FLAIR";
    HighlightedPostLabel[HighlightedPostLabel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HighlightedPostLabel || (HighlightedPostLabel = {}));
export function highlightedPostLabelFromJSON(object) {
    switch (object) {
        case 0:
        case "HIGHLIGHTED_POST_LABEL_UNSPECIFIED":
            return HighlightedPostLabel.HIGHLIGHTED_POST_LABEL_UNSPECIFIED;
        case 1:
        case "ANNOUNCEMENT":
            return HighlightedPostLabel.ANNOUNCEMENT;
        case 2:
        case "EVENT":
            return HighlightedPostLabel.EVENT;
        case 3:
        case "MEGATHREAD":
            return HighlightedPostLabel.MEGATHREAD;
        case 4:
        case "SHOW_POST_FLAIR":
            return HighlightedPostLabel.SHOW_POST_FLAIR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return HighlightedPostLabel.UNRECOGNIZED;
    }
}
export function highlightedPostLabelToJSON(object) {
    switch (object) {
        case HighlightedPostLabel.HIGHLIGHTED_POST_LABEL_UNSPECIFIED:
            return 0;
        case HighlightedPostLabel.ANNOUNCEMENT:
            return 1;
        case HighlightedPostLabel.EVENT:
            return 2;
        case HighlightedPostLabel.MEGATHREAD:
            return 3;
        case HighlightedPostLabel.SHOW_POST_FLAIR:
            return 4;
        case HighlightedPostLabel.UNRECOGNIZED:
        default:
            return -1;
    }
}
/** Indicates who the request should be made on behalf of. Currently, only 'APP' or 'USER' types are supported. */
export var RunAs;
(function (RunAs) {
    RunAs[RunAs["APP"] = 0] = "APP";
    RunAs[RunAs["USER"] = 1] = "USER";
    RunAs[RunAs["UNSPECIFIED"] = 2] = "UNSPECIFIED";
    RunAs[RunAs["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RunAs || (RunAs = {}));
export function runAsFromJSON(object) {
    switch (object) {
        case 0:
        case "APP":
            return RunAs.APP;
        case 1:
        case "USER":
            return RunAs.USER;
        case 2:
        case "UNSPECIFIED":
            return RunAs.UNSPECIFIED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RunAs.UNRECOGNIZED;
    }
}
export function runAsToJSON(object) {
    switch (object) {
        case RunAs.APP:
            return 0;
        case RunAs.USER:
            return 1;
        case RunAs.UNSPECIFIED:
            return 2;
        case RunAs.UNRECOGNIZED:
        default:
            return -1;
    }
}
export var GalleryMediaStatus;
(function (GalleryMediaStatus) {
    GalleryMediaStatus[GalleryMediaStatus["GALLERY_MEDIA_STATUS_UNSPECIFIED"] = 0] = "GALLERY_MEDIA_STATUS_UNSPECIFIED";
    GalleryMediaStatus[GalleryMediaStatus["GALLERY_MEDIA_STATUS_VALID"] = 1] = "GALLERY_MEDIA_STATUS_VALID";
    GalleryMediaStatus[GalleryMediaStatus["GALLERY_MEDIA_STATUS_FAILED"] = 2] = "GALLERY_MEDIA_STATUS_FAILED";
    GalleryMediaStatus[GalleryMediaStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(GalleryMediaStatus || (GalleryMediaStatus = {}));
export function galleryMediaStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "GALLERY_MEDIA_STATUS_UNSPECIFIED":
            return GalleryMediaStatus.GALLERY_MEDIA_STATUS_UNSPECIFIED;
        case 1:
        case "GALLERY_MEDIA_STATUS_VALID":
            return GalleryMediaStatus.GALLERY_MEDIA_STATUS_VALID;
        case 2:
        case "GALLERY_MEDIA_STATUS_FAILED":
            return GalleryMediaStatus.GALLERY_MEDIA_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return GalleryMediaStatus.UNRECOGNIZED;
    }
}
export function galleryMediaStatusToJSON(object) {
    switch (object) {
        case GalleryMediaStatus.GALLERY_MEDIA_STATUS_UNSPECIFIED:
            return 0;
        case GalleryMediaStatus.GALLERY_MEDIA_STATUS_VALID:
            return 1;
        case GalleryMediaStatus.GALLERY_MEDIA_STATUS_FAILED:
            return 2;
        case GalleryMediaStatus.UNRECOGNIZED:
        default:
            return -1;
    }
}
/** For methods with a request body, this specifies how the request body should be serialized. */
export var ApiClientConfig_BodyType;
(function (ApiClientConfig_BodyType) {
    ApiClientConfig_BodyType[ApiClientConfig_BodyType["NONE"] = 0] = "NONE";
    ApiClientConfig_BodyType[ApiClientConfig_BodyType["JSON_CAMEL"] = 1] = "JSON_CAMEL";
    ApiClientConfig_BodyType[ApiClientConfig_BodyType["JSON_SNAKE"] = 2] = "JSON_SNAKE";
    ApiClientConfig_BodyType[ApiClientConfig_BodyType["FORM_CAMEL"] = 3] = "FORM_CAMEL";
    ApiClientConfig_BodyType[ApiClientConfig_BodyType["FORM_SNAKE"] = 4] = "FORM_SNAKE";
    ApiClientConfig_BodyType[ApiClientConfig_BodyType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ApiClientConfig_BodyType || (ApiClientConfig_BodyType = {}));
export function apiClientConfig_BodyTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "NONE":
            return ApiClientConfig_BodyType.NONE;
        case 1:
        case "JSON_CAMEL":
            return ApiClientConfig_BodyType.JSON_CAMEL;
        case 2:
        case "JSON_SNAKE":
            return ApiClientConfig_BodyType.JSON_SNAKE;
        case 3:
        case "FORM_CAMEL":
            return ApiClientConfig_BodyType.FORM_CAMEL;
        case 4:
        case "FORM_SNAKE":
            return ApiClientConfig_BodyType.FORM_SNAKE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ApiClientConfig_BodyType.UNRECOGNIZED;
    }
}
export function apiClientConfig_BodyTypeToJSON(object) {
    switch (object) {
        case ApiClientConfig_BodyType.NONE:
            return 0;
        case ApiClientConfig_BodyType.JSON_CAMEL:
            return 1;
        case ApiClientConfig_BodyType.JSON_SNAKE:
            return 2;
        case ApiClientConfig_BodyType.FORM_CAMEL:
            return 3;
        case ApiClientConfig_BodyType.FORM_SNAKE:
            return 4;
        case ApiClientConfig_BodyType.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseListing() {
    return { kind: "", data: undefined };
}
export const Listing = {
    $type: "devvit.plugin.redditapi.common.Listing",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            Listing_ListingData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = Listing_ListingData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? Listing_ListingData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = Listing_ListingData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return Listing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListing();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? Listing_ListingData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(Listing.$type, Listing);
function createBaseListing_ListingData() {
    return { after: undefined, before: undefined, children: [], dist: undefined };
}
export const Listing_ListingData = {
    $type: "devvit.plugin.redditapi.common.Listing.ListingData",
    encode(message, writer = _m0.Writer.create()) {
        if (message.after !== undefined) {
            StringValue.encode({ value: message.after }, writer.uint32(10).fork()).ldelim();
        }
        if (message.before !== undefined) {
            StringValue.encode({ value: message.before }, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.children) {
            WrappedRedditObject.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.dist !== undefined) {
            Int64Value.encode({ value: message.dist }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListing_ListingData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.after = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.before = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.children.push(WrappedRedditObject.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.dist = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            after: isSet(object.after) ? String(object.after) : undefined,
            before: isSet(object.before) ? String(object.before) : undefined,
            children: globalThis.Array.isArray(object?.children)
                ? object.children.map((e) => WrappedRedditObject.fromJSON(e))
                : [],
            dist: isSet(object.dist) ? Number(object.dist) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.after !== undefined) {
            obj.after = message.after;
        }
        if (message.before !== undefined) {
            obj.before = message.before;
        }
        if (message.children?.length) {
            obj.children = message.children.map((e) => WrappedRedditObject.toJSON(e));
        }
        if (message.dist !== undefined) {
            obj.dist = message.dist;
        }
        return obj;
    },
    create(base) {
        return Listing_ListingData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListing_ListingData();
        message.after = object.after ?? undefined;
        message.before = object.before ?? undefined;
        message.children = object.children?.map((e) => WrappedRedditObject.fromPartial(e)) || [];
        message.dist = object.dist ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(Listing_ListingData.$type, Listing_ListingData);
function createBaseWrappedRedditObject() {
    return { kind: "", data: undefined };
}
export const WrappedRedditObject = {
    $type: "devvit.plugin.redditapi.common.WrappedRedditObject",
    encode(message, writer = _m0.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.data !== undefined) {
            RedditObject.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWrappedRedditObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = RedditObject.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            data: isSet(object.data) ? RedditObject.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.data !== undefined) {
            obj.data = RedditObject.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return WrappedRedditObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWrappedRedditObject();
        message.kind = object.kind ?? "";
        message.data = (object.data !== undefined && object.data !== null)
            ? RedditObject.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(WrappedRedditObject.$type, WrappedRedditObject);
function createBaseJsonRedditObjects() {
    return { json: undefined };
}
export const JsonRedditObjects = {
    $type: "devvit.plugin.redditapi.common.JsonRedditObjects",
    encode(message, writer = _m0.Writer.create()) {
        if (message.json !== undefined) {
            JsonRedditObjects_JsonType.encode(message.json, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJsonRedditObjects();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.json = JsonRedditObjects_JsonType.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { json: isSet(object.json) ? JsonRedditObjects_JsonType.fromJSON(object.json) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.json !== undefined) {
            obj.json = JsonRedditObjects_JsonType.toJSON(message.json);
        }
        return obj;
    },
    create(base) {
        return JsonRedditObjects.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJsonRedditObjects();
        message.json = (object.json !== undefined && object.json !== null)
            ? JsonRedditObjects_JsonType.fromPartial(object.json)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(JsonRedditObjects.$type, JsonRedditObjects);
function createBaseJsonRedditObjects_JsonType() {
    return { errors: [], data: undefined };
}
export const JsonRedditObjects_JsonType = {
    $type: "devvit.plugin.redditapi.common.JsonRedditObjects.JsonType",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.errors) {
            Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            JsonRedditObjects_JsonType_JsonData.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJsonRedditObjects_JsonType();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.errors.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = JsonRedditObjects_JsonType_JsonData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e) => Any.fromJSON(e)) : [],
            data: isSet(object.data) ? JsonRedditObjects_JsonType_JsonData.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.errors?.length) {
            obj.errors = message.errors.map((e) => Any.toJSON(e));
        }
        if (message.data !== undefined) {
            obj.data = JsonRedditObjects_JsonType_JsonData.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return JsonRedditObjects_JsonType.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJsonRedditObjects_JsonType();
        message.errors = object.errors?.map((e) => Any.fromPartial(e)) || [];
        message.data = (object.data !== undefined && object.data !== null)
            ? JsonRedditObjects_JsonType_JsonData.fromPartial(object.data)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(JsonRedditObjects_JsonType.$type, JsonRedditObjects_JsonType);
function createBaseJsonRedditObjects_JsonType_JsonData() {
    return { things: [] };
}
export const JsonRedditObjects_JsonType_JsonData = {
    $type: "devvit.plugin.redditapi.common.JsonRedditObjects.JsonType.JsonData",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.things) {
            WrappedRedditObject.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJsonRedditObjects_JsonType_JsonData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.things.push(WrappedRedditObject.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            things: globalThis.Array.isArray(object?.things)
                ? object.things.map((e) => WrappedRedditObject.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.things?.length) {
            obj.things = message.things.map((e) => WrappedRedditObject.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return JsonRedditObjects_JsonType_JsonData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJsonRedditObjects_JsonType_JsonData();
        message.things = object.things?.map((e) => WrappedRedditObject.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(JsonRedditObjects_JsonType_JsonData.$type, JsonRedditObjects_JsonType_JsonData);
function createBaseRedditObject() {
    return {
        allAwardings: [],
        approved: undefined,
        approvedAtUtc: undefined,
        approvedBy: undefined,
        archived: undefined,
        associatedAward: undefined,
        author: undefined,
        authorFlairBackgroundColor: undefined,
        authorFlairCssClass: undefined,
        authorFlairRichtext: [],
        authorFlairTemplateId: undefined,
        authorFlairText: undefined,
        authorFlairTextColor: undefined,
        authorFlairType: undefined,
        authorFullname: undefined,
        authorIsBlocked: undefined,
        authorPatreonFlair: undefined,
        authorPremium: undefined,
        awarders: [],
        bannedAtUtc: undefined,
        bannedBy: undefined,
        body: undefined,
        bodyHtml: undefined,
        canGild: undefined,
        canModPost: undefined,
        collapsed: undefined,
        collapsedBecauseCrowdControl: undefined,
        collapsedReason: undefined,
        collapsedReasonCode: undefined,
        commentType: undefined,
        controversiality: undefined,
        created: undefined,
        createdUtc: undefined,
        distinguished: undefined,
        downs: undefined,
        edited: undefined,
        gilded: undefined,
        gildings: undefined,
        id: undefined,
        ignoreReports: undefined,
        isSubmitter: undefined,
        likes: undefined,
        linkId: undefined,
        locked: undefined,
        modNote: undefined,
        modReasonBy: undefined,
        modReasonTitle: undefined,
        name: undefined,
        noFollow: undefined,
        numReports: undefined,
        parentId: undefined,
        permalink: undefined,
        removalReason: undefined,
        removed: undefined,
        replies: undefined,
        reportReasons: undefined,
        rteMode: undefined,
        saved: undefined,
        score: undefined,
        scoreHidden: undefined,
        sendReplies: undefined,
        spam: undefined,
        stickied: undefined,
        subreddit: undefined,
        subredditId: undefined,
        subredditNamePrefixed: undefined,
        subredditType: undefined,
        topAwardedType: undefined,
        totalAwardsReceived: undefined,
        treatmentTags: [],
        unrepliableReason: undefined,
        ups: undefined,
        depth: undefined,
        linkTitle: undefined,
        linkAuthor: undefined,
        numComments: undefined,
        over18: undefined,
        linkPermalink: undefined,
        quarantine: undefined,
        linkUrl: undefined,
        selftext: undefined,
        selftextHtml: undefined,
        thumbnail: undefined,
        thumbnailWidth: undefined,
        thumbnailHeight: undefined,
        title: undefined,
        url: undefined,
        displayName: undefined,
        modPermissions: [],
        count: undefined,
        children: undefined,
        replyList: undefined,
        hidden: undefined,
        linkFlairBackgroundColor: undefined,
        linkFlairCssClass: undefined,
        linkFlairRichtext: [],
        linkFlairTemplateId: undefined,
        linkFlairText: undefined,
        linkFlairTextColor: undefined,
        linkFlairType: undefined,
        secureMedia: undefined,
        spoiler: false,
        modReports: [],
        userReports: [],
        removedBy: undefined,
        removedByCategory: undefined,
        gallery: [],
        pollData: undefined,
        crosspostParent: undefined,
        daysLeft: undefined,
        date: undefined,
        note: undefined,
    };
}
export const RedditObject = {
    $type: "devvit.plugin.redditapi.common.RedditObject",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.allAwardings) {
            Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.approved !== undefined) {
            BoolValue.encode({ value: message.approved }, writer.uint32(18).fork()).ldelim();
        }
        if (message.approvedAtUtc !== undefined) {
            Int64Value.encode({ value: message.approvedAtUtc }, writer.uint32(26).fork()).ldelim();
        }
        if (message.approvedBy !== undefined) {
            StringValue.encode({ value: message.approvedBy }, writer.uint32(34).fork()).ldelim();
        }
        if (message.archived !== undefined) {
            BoolValue.encode({ value: message.archived }, writer.uint32(42).fork()).ldelim();
        }
        if (message.associatedAward !== undefined) {
            StringValue.encode({ value: message.associatedAward }, writer.uint32(50).fork()).ldelim();
        }
        if (message.author !== undefined) {
            StringValue.encode({ value: message.author }, writer.uint32(58).fork()).ldelim();
        }
        if (message.authorFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.authorFlairBackgroundColor }, writer.uint32(66).fork()).ldelim();
        }
        if (message.authorFlairCssClass !== undefined) {
            StringValue.encode({ value: message.authorFlairCssClass }, writer.uint32(74).fork()).ldelim();
        }
        for (const v of message.authorFlairRichtext) {
            RedditObject_AuthorFlairRichText.encode(v, writer.uint32(82).fork()).ldelim();
        }
        if (message.authorFlairTemplateId !== undefined) {
            StringValue.encode({ value: message.authorFlairTemplateId }, writer.uint32(90).fork()).ldelim();
        }
        if (message.authorFlairText !== undefined) {
            StringValue.encode({ value: message.authorFlairText }, writer.uint32(98).fork()).ldelim();
        }
        if (message.authorFlairTextColor !== undefined) {
            StringValue.encode({ value: message.authorFlairTextColor }, writer.uint32(106).fork()).ldelim();
        }
        if (message.authorFlairType !== undefined) {
            StringValue.encode({ value: message.authorFlairType }, writer.uint32(114).fork()).ldelim();
        }
        if (message.authorFullname !== undefined) {
            StringValue.encode({ value: message.authorFullname }, writer.uint32(122).fork()).ldelim();
        }
        if (message.authorIsBlocked !== undefined) {
            BoolValue.encode({ value: message.authorIsBlocked }, writer.uint32(130).fork()).ldelim();
        }
        if (message.authorPatreonFlair !== undefined) {
            BoolValue.encode({ value: message.authorPatreonFlair }, writer.uint32(138).fork()).ldelim();
        }
        if (message.authorPremium !== undefined) {
            BoolValue.encode({ value: message.authorPremium }, writer.uint32(146).fork()).ldelim();
        }
        for (const v of message.awarders) {
            StringValue.encode({ value: v }, writer.uint32(154).fork()).ldelim();
        }
        if (message.bannedAtUtc !== undefined) {
            Int64Value.encode({ value: message.bannedAtUtc }, writer.uint32(162).fork()).ldelim();
        }
        if (message.bannedBy !== undefined) {
            StringValue.encode({ value: message.bannedBy }, writer.uint32(170).fork()).ldelim();
        }
        if (message.body !== undefined) {
            StringValue.encode({ value: message.body }, writer.uint32(178).fork()).ldelim();
        }
        if (message.bodyHtml !== undefined) {
            StringValue.encode({ value: message.bodyHtml }, writer.uint32(186).fork()).ldelim();
        }
        if (message.canGild !== undefined) {
            BoolValue.encode({ value: message.canGild }, writer.uint32(194).fork()).ldelim();
        }
        if (message.canModPost !== undefined) {
            BoolValue.encode({ value: message.canModPost }, writer.uint32(202).fork()).ldelim();
        }
        if (message.collapsed !== undefined) {
            BoolValue.encode({ value: message.collapsed }, writer.uint32(210).fork()).ldelim();
        }
        if (message.collapsedBecauseCrowdControl !== undefined) {
            BoolValue.encode({ value: message.collapsedBecauseCrowdControl }, writer.uint32(218).fork()).ldelim();
        }
        if (message.collapsedReason !== undefined) {
            StringValue.encode({ value: message.collapsedReason }, writer.uint32(226).fork()).ldelim();
        }
        if (message.collapsedReasonCode !== undefined) {
            StringValue.encode({ value: message.collapsedReasonCode }, writer.uint32(234).fork()).ldelim();
        }
        if (message.commentType !== undefined) {
            StringValue.encode({ value: message.commentType }, writer.uint32(242).fork()).ldelim();
        }
        if (message.controversiality !== undefined) {
            Int64Value.encode({ value: message.controversiality }, writer.uint32(250).fork()).ldelim();
        }
        if (message.created !== undefined) {
            Int64Value.encode({ value: message.created }, writer.uint32(258).fork()).ldelim();
        }
        if (message.createdUtc !== undefined) {
            Int64Value.encode({ value: message.createdUtc }, writer.uint32(266).fork()).ldelim();
        }
        if (message.distinguished !== undefined) {
            StringValue.encode({ value: message.distinguished }, writer.uint32(274).fork()).ldelim();
        }
        if (message.downs !== undefined) {
            Int64Value.encode({ value: message.downs }, writer.uint32(282).fork()).ldelim();
        }
        if (message.edited !== undefined) {
            BoolValue.encode({ value: message.edited }, writer.uint32(290).fork()).ldelim();
        }
        if (message.gilded !== undefined) {
            Int64Value.encode({ value: message.gilded }, writer.uint32(298).fork()).ldelim();
        }
        if (message.gildings !== undefined) {
            Any.encode(message.gildings, writer.uint32(306).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(314).fork()).ldelim();
        }
        if (message.ignoreReports !== undefined) {
            BoolValue.encode({ value: message.ignoreReports }, writer.uint32(322).fork()).ldelim();
        }
        if (message.isSubmitter !== undefined) {
            BoolValue.encode({ value: message.isSubmitter }, writer.uint32(330).fork()).ldelim();
        }
        if (message.likes !== undefined) {
            BoolValue.encode({ value: message.likes }, writer.uint32(338).fork()).ldelim();
        }
        if (message.linkId !== undefined) {
            StringValue.encode({ value: message.linkId }, writer.uint32(346).fork()).ldelim();
        }
        if (message.locked !== undefined) {
            BoolValue.encode({ value: message.locked }, writer.uint32(354).fork()).ldelim();
        }
        if (message.modNote !== undefined) {
            StringValue.encode({ value: message.modNote }, writer.uint32(362).fork()).ldelim();
        }
        if (message.modReasonBy !== undefined) {
            StringValue.encode({ value: message.modReasonBy }, writer.uint32(370).fork()).ldelim();
        }
        if (message.modReasonTitle !== undefined) {
            StringValue.encode({ value: message.modReasonTitle }, writer.uint32(378).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(394).fork()).ldelim();
        }
        if (message.noFollow !== undefined) {
            BoolValue.encode({ value: message.noFollow }, writer.uint32(402).fork()).ldelim();
        }
        if (message.numReports !== undefined) {
            Int64Value.encode({ value: message.numReports }, writer.uint32(418).fork()).ldelim();
        }
        if (message.parentId !== undefined) {
            StringValue.encode({ value: message.parentId }, writer.uint32(426).fork()).ldelim();
        }
        if (message.permalink !== undefined) {
            StringValue.encode({ value: message.permalink }, writer.uint32(434).fork()).ldelim();
        }
        if (message.removalReason !== undefined) {
            StringValue.encode({ value: message.removalReason }, writer.uint32(442).fork()).ldelim();
        }
        if (message.removed !== undefined) {
            BoolValue.encode({ value: message.removed }, writer.uint32(450).fork()).ldelim();
        }
        if (message.replies !== undefined) {
            StringValue.encode({ value: message.replies }, writer.uint32(458).fork()).ldelim();
        }
        if (message.reportReasons !== undefined) {
            ListValue.encode(ListValue.wrap(message.reportReasons), writer.uint32(466).fork()).ldelim();
        }
        if (message.rteMode !== undefined) {
            StringValue.encode({ value: message.rteMode }, writer.uint32(474).fork()).ldelim();
        }
        if (message.saved !== undefined) {
            BoolValue.encode({ value: message.saved }, writer.uint32(482).fork()).ldelim();
        }
        if (message.score !== undefined) {
            Int64Value.encode({ value: message.score }, writer.uint32(490).fork()).ldelim();
        }
        if (message.scoreHidden !== undefined) {
            BoolValue.encode({ value: message.scoreHidden }, writer.uint32(498).fork()).ldelim();
        }
        if (message.sendReplies !== undefined) {
            BoolValue.encode({ value: message.sendReplies }, writer.uint32(506).fork()).ldelim();
        }
        if (message.spam !== undefined) {
            BoolValue.encode({ value: message.spam }, writer.uint32(514).fork()).ldelim();
        }
        if (message.stickied !== undefined) {
            BoolValue.encode({ value: message.stickied }, writer.uint32(522).fork()).ldelim();
        }
        if (message.subreddit !== undefined) {
            StringValue.encode({ value: message.subreddit }, writer.uint32(530).fork()).ldelim();
        }
        if (message.subredditId !== undefined) {
            StringValue.encode({ value: message.subredditId }, writer.uint32(538).fork()).ldelim();
        }
        if (message.subredditNamePrefixed !== undefined) {
            StringValue.encode({ value: message.subredditNamePrefixed }, writer.uint32(546).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(554).fork()).ldelim();
        }
        if (message.topAwardedType !== undefined) {
            StringValue.encode({ value: message.topAwardedType }, writer.uint32(562).fork()).ldelim();
        }
        if (message.totalAwardsReceived !== undefined) {
            Int64Value.encode({ value: message.totalAwardsReceived }, writer.uint32(570).fork()).ldelim();
        }
        for (const v of message.treatmentTags) {
            Any.encode(v, writer.uint32(578).fork()).ldelim();
        }
        if (message.unrepliableReason !== undefined) {
            StringValue.encode({ value: message.unrepliableReason }, writer.uint32(586).fork()).ldelim();
        }
        if (message.ups !== undefined) {
            Int64Value.encode({ value: message.ups }, writer.uint32(594).fork()).ldelim();
        }
        if (message.depth !== undefined) {
            Int64Value.encode({ value: message.depth }, writer.uint32(610).fork()).ldelim();
        }
        if (message.linkTitle !== undefined) {
            StringValue.encode({ value: message.linkTitle }, writer.uint32(618).fork()).ldelim();
        }
        if (message.linkAuthor !== undefined) {
            StringValue.encode({ value: message.linkAuthor }, writer.uint32(626).fork()).ldelim();
        }
        if (message.numComments !== undefined) {
            Int64Value.encode({ value: message.numComments }, writer.uint32(634).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(642).fork()).ldelim();
        }
        if (message.linkPermalink !== undefined) {
            StringValue.encode({ value: message.linkPermalink }, writer.uint32(650).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(658).fork()).ldelim();
        }
        if (message.linkUrl !== undefined) {
            StringValue.encode({ value: message.linkUrl }, writer.uint32(666).fork()).ldelim();
        }
        if (message.selftext !== undefined) {
            StringValue.encode({ value: message.selftext }, writer.uint32(674).fork()).ldelim();
        }
        if (message.selftextHtml !== undefined) {
            StringValue.encode({ value: message.selftextHtml }, writer.uint32(682).fork()).ldelim();
        }
        if (message.thumbnail !== undefined) {
            StringValue.encode({ value: message.thumbnail }, writer.uint32(698).fork()).ldelim();
        }
        if (message.thumbnailWidth !== undefined) {
            Int64Value.encode({ value: message.thumbnailWidth }, writer.uint32(706).fork()).ldelim();
        }
        if (message.thumbnailHeight !== undefined) {
            Int64Value.encode({ value: message.thumbnailHeight }, writer.uint32(714).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(722).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(730).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(738).fork()).ldelim();
        }
        for (const v of message.modPermissions) {
            StringValue.encode({ value: v }, writer.uint32(746).fork()).ldelim();
        }
        if (message.count !== undefined) {
            Int64Value.encode({ value: message.count }, writer.uint32(754).fork()).ldelim();
        }
        if (message.children !== undefined) {
            ListValue.encode(ListValue.wrap(message.children), writer.uint32(762).fork()).ldelim();
        }
        if (message.replyList !== undefined) {
            Listing.encode(message.replyList, writer.uint32(770).fork()).ldelim();
        }
        if (message.hidden !== undefined) {
            BoolValue.encode({ value: message.hidden }, writer.uint32(778).fork()).ldelim();
        }
        if (message.linkFlairBackgroundColor !== undefined) {
            StringValue.encode({ value: message.linkFlairBackgroundColor }, writer.uint32(786).fork()).ldelim();
        }
        if (message.linkFlairCssClass !== undefined) {
            StringValue.encode({ value: message.linkFlairCssClass }, writer.uint32(794).fork()).ldelim();
        }
        for (const v of message.linkFlairRichtext) {
            RedditObject_LinkFlairRichText.encode(v, writer.uint32(802).fork()).ldelim();
        }
        if (message.linkFlairTemplateId !== undefined) {
            StringValue.encode({ value: message.linkFlairTemplateId }, writer.uint32(810).fork()).ldelim();
        }
        if (message.linkFlairText !== undefined) {
            StringValue.encode({ value: message.linkFlairText }, writer.uint32(818).fork()).ldelim();
        }
        if (message.linkFlairTextColor !== undefined) {
            StringValue.encode({ value: message.linkFlairTextColor }, writer.uint32(826).fork()).ldelim();
        }
        if (message.linkFlairType !== undefined) {
            StringValue.encode({ value: message.linkFlairType }, writer.uint32(834).fork()).ldelim();
        }
        if (message.secureMedia !== undefined) {
            RedditObject_SecureMedia.encode(message.secureMedia, writer.uint32(842).fork()).ldelim();
        }
        if (message.spoiler !== false) {
            writer.uint32(848).bool(message.spoiler);
        }
        for (const v of message.modReports) {
            ListValue.encode(ListValue.wrap(v), writer.uint32(858).fork()).ldelim();
        }
        for (const v of message.userReports) {
            ListValue.encode(ListValue.wrap(v), writer.uint32(866).fork()).ldelim();
        }
        if (message.removedBy !== undefined) {
            StringValue.encode({ value: message.removedBy }, writer.uint32(874).fork()).ldelim();
        }
        if (message.removedByCategory !== undefined) {
            StringValue.encode({ value: message.removedByCategory }, writer.uint32(882).fork()).ldelim();
        }
        for (const v of message.gallery) {
            RedditObject_GalleryMedia.encode(v, writer.uint32(890).fork()).ldelim();
        }
        if (message.pollData !== undefined) {
            PollData.encode(message.pollData, writer.uint32(898).fork()).ldelim();
        }
        if (message.crosspostParent !== undefined) {
            writer.uint32(906).string(message.crosspostParent);
        }
        if (message.daysLeft !== undefined) {
            writer.uint32(912).int32(message.daysLeft);
        }
        if (message.date !== undefined) {
            writer.uint32(920).int32(message.date);
        }
        if (message.note !== undefined) {
            writer.uint32(930).string(message.note);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.allAwardings.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.approved = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.approvedAtUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.approvedBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.archived = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.associatedAward = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.author = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.authorFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.authorFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.authorFlairRichtext.push(RedditObject_AuthorFlairRichText.decode(reader, reader.uint32()));
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.authorFlairTemplateId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.authorFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.authorFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.authorFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.authorFullname = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.authorIsBlocked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.authorPatreonFlair = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.authorPremium = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.awarders.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.bannedAtUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.bannedBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.body = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.bodyHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.canGild = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.canModPost = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.collapsed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.collapsedBecauseCrowdControl = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.collapsedReason = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.collapsedReasonCode = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.commentType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.controversiality = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.created = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.createdUtc = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.distinguished = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.downs = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.edited = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.gilded = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.gildings = Any.decode(reader, reader.uint32());
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.ignoreReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.isSubmitter = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.likes = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.linkId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 354) {
                        break;
                    }
                    message.locked = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.modNote = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.modReasonBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.modReasonTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.noFollow = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.numReports = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.parentId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.permalink = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.removalReason = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.removed = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.replies = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 58:
                    if (tag !== 466) {
                        break;
                    }
                    message.reportReasons = ListValue.unwrap(ListValue.decode(reader, reader.uint32()));
                    continue;
                case 59:
                    if (tag !== 474) {
                        break;
                    }
                    message.rteMode = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 60:
                    if (tag !== 482) {
                        break;
                    }
                    message.saved = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 61:
                    if (tag !== 490) {
                        break;
                    }
                    message.score = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 62:
                    if (tag !== 498) {
                        break;
                    }
                    message.scoreHidden = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 63:
                    if (tag !== 506) {
                        break;
                    }
                    message.sendReplies = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 64:
                    if (tag !== 514) {
                        break;
                    }
                    message.spam = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 65:
                    if (tag !== 522) {
                        break;
                    }
                    message.stickied = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 66:
                    if (tag !== 530) {
                        break;
                    }
                    message.subreddit = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 67:
                    if (tag !== 538) {
                        break;
                    }
                    message.subredditId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 68:
                    if (tag !== 546) {
                        break;
                    }
                    message.subredditNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 69:
                    if (tag !== 554) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 70:
                    if (tag !== 562) {
                        break;
                    }
                    message.topAwardedType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 71:
                    if (tag !== 570) {
                        break;
                    }
                    message.totalAwardsReceived = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 72:
                    if (tag !== 578) {
                        break;
                    }
                    message.treatmentTags.push(Any.decode(reader, reader.uint32()));
                    continue;
                case 73:
                    if (tag !== 586) {
                        break;
                    }
                    message.unrepliableReason = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 74:
                    if (tag !== 594) {
                        break;
                    }
                    message.ups = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 76:
                    if (tag !== 610) {
                        break;
                    }
                    message.depth = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 77:
                    if (tag !== 618) {
                        break;
                    }
                    message.linkTitle = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 78:
                    if (tag !== 626) {
                        break;
                    }
                    message.linkAuthor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 79:
                    if (tag !== 634) {
                        break;
                    }
                    message.numComments = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 80:
                    if (tag !== 642) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 81:
                    if (tag !== 650) {
                        break;
                    }
                    message.linkPermalink = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 82:
                    if (tag !== 658) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 83:
                    if (tag !== 666) {
                        break;
                    }
                    message.linkUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 84:
                    if (tag !== 674) {
                        break;
                    }
                    message.selftext = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 85:
                    if (tag !== 682) {
                        break;
                    }
                    message.selftextHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 87:
                    if (tag !== 698) {
                        break;
                    }
                    message.thumbnail = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 88:
                    if (tag !== 706) {
                        break;
                    }
                    message.thumbnailWidth = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 89:
                    if (tag !== 714) {
                        break;
                    }
                    message.thumbnailHeight = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 90:
                    if (tag !== 722) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 91:
                    if (tag !== 730) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 92:
                    if (tag !== 738) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 93:
                    if (tag !== 746) {
                        break;
                    }
                    message.modPermissions.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 94:
                    if (tag !== 754) {
                        break;
                    }
                    message.count = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 95:
                    if (tag !== 762) {
                        break;
                    }
                    message.children = ListValue.unwrap(ListValue.decode(reader, reader.uint32()));
                    continue;
                case 96:
                    if (tag !== 770) {
                        break;
                    }
                    message.replyList = Listing.decode(reader, reader.uint32());
                    continue;
                case 97:
                    if (tag !== 778) {
                        break;
                    }
                    message.hidden = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 98:
                    if (tag !== 786) {
                        break;
                    }
                    message.linkFlairBackgroundColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 99:
                    if (tag !== 794) {
                        break;
                    }
                    message.linkFlairCssClass = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.linkFlairRichtext.push(RedditObject_LinkFlairRichText.decode(reader, reader.uint32()));
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.linkFlairTemplateId = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.linkFlairText = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.linkFlairTextColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.linkFlairType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.secureMedia = RedditObject_SecureMedia.decode(reader, reader.uint32());
                    continue;
                case 106:
                    if (tag !== 848) {
                        break;
                    }
                    message.spoiler = reader.bool();
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.modReports.push(ListValue.unwrap(ListValue.decode(reader, reader.uint32())));
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.userReports.push(ListValue.unwrap(ListValue.decode(reader, reader.uint32())));
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.removedBy = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.removedByCategory = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.gallery.push(RedditObject_GalleryMedia.decode(reader, reader.uint32()));
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.pollData = PollData.decode(reader, reader.uint32());
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.crosspostParent = reader.string();
                    continue;
                case 114:
                    if (tag !== 912) {
                        break;
                    }
                    message.daysLeft = reader.int32();
                    continue;
                case 115:
                    if (tag !== 920) {
                        break;
                    }
                    message.date = reader.int32();
                    continue;
                case 116:
                    if (tag !== 930) {
                        break;
                    }
                    message.note = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            allAwardings: globalThis.Array.isArray(object?.allAwardings)
                ? object.allAwardings.map((e) => Any.fromJSON(e))
                : [],
            approved: isSet(object.approved) ? Boolean(object.approved) : undefined,
            approvedAtUtc: isSet(object.approvedAtUtc) ? Number(object.approvedAtUtc) : undefined,
            approvedBy: isSet(object.approvedBy) ? String(object.approvedBy) : undefined,
            archived: isSet(object.archived) ? Boolean(object.archived) : undefined,
            associatedAward: isSet(object.associatedAward) ? String(object.associatedAward) : undefined,
            author: isSet(object.author) ? String(object.author) : undefined,
            authorFlairBackgroundColor: isSet(object.authorFlairBackgroundColor)
                ? String(object.authorFlairBackgroundColor)
                : undefined,
            authorFlairCssClass: isSet(object.authorFlairCssClass) ? String(object.authorFlairCssClass) : undefined,
            authorFlairRichtext: globalThis.Array.isArray(object?.authorFlairRichtext)
                ? object.authorFlairRichtext.map((e) => RedditObject_AuthorFlairRichText.fromJSON(e))
                : [],
            authorFlairTemplateId: isSet(object.authorFlairTemplateId) ? String(object.authorFlairTemplateId) : undefined,
            authorFlairText: isSet(object.authorFlairText) ? String(object.authorFlairText) : undefined,
            authorFlairTextColor: isSet(object.authorFlairTextColor) ? String(object.authorFlairTextColor) : undefined,
            authorFlairType: isSet(object.authorFlairType) ? String(object.authorFlairType) : undefined,
            authorFullname: isSet(object.authorFullname) ? String(object.authorFullname) : undefined,
            authorIsBlocked: isSet(object.authorIsBlocked) ? Boolean(object.authorIsBlocked) : undefined,
            authorPatreonFlair: isSet(object.authorPatreonFlair) ? Boolean(object.authorPatreonFlair) : undefined,
            authorPremium: isSet(object.authorPremium) ? Boolean(object.authorPremium) : undefined,
            awarders: globalThis.Array.isArray(object?.awarders) ? object.awarders.map((e) => String(e)) : [],
            bannedAtUtc: isSet(object.bannedAtUtc) ? Number(object.bannedAtUtc) : undefined,
            bannedBy: isSet(object.bannedBy) ? String(object.bannedBy) : undefined,
            body: isSet(object.body) ? String(object.body) : undefined,
            bodyHtml: isSet(object.bodyHtml) ? String(object.bodyHtml) : undefined,
            canGild: isSet(object.canGild) ? Boolean(object.canGild) : undefined,
            canModPost: isSet(object.canModPost) ? Boolean(object.canModPost) : undefined,
            collapsed: isSet(object.collapsed) ? Boolean(object.collapsed) : undefined,
            collapsedBecauseCrowdControl: isSet(object.collapsedBecauseCrowdControl)
                ? Boolean(object.collapsedBecauseCrowdControl)
                : undefined,
            collapsedReason: isSet(object.collapsedReason) ? String(object.collapsedReason) : undefined,
            collapsedReasonCode: isSet(object.collapsedReasonCode) ? String(object.collapsedReasonCode) : undefined,
            commentType: isSet(object.commentType) ? String(object.commentType) : undefined,
            controversiality: isSet(object.controversiality) ? Number(object.controversiality) : undefined,
            created: isSet(object.created) ? Number(object.created) : undefined,
            createdUtc: isSet(object.createdUtc) ? Number(object.createdUtc) : undefined,
            distinguished: isSet(object.distinguished) ? String(object.distinguished) : undefined,
            downs: isSet(object.downs) ? Number(object.downs) : undefined,
            edited: isSet(object.edited) ? Boolean(object.edited) : undefined,
            gilded: isSet(object.gilded) ? Number(object.gilded) : undefined,
            gildings: isSet(object.gildings) ? Any.fromJSON(object.gildings) : undefined,
            id: isSet(object.id) ? String(object.id) : undefined,
            ignoreReports: isSet(object.ignoreReports) ? Boolean(object.ignoreReports) : undefined,
            isSubmitter: isSet(object.isSubmitter) ? Boolean(object.isSubmitter) : undefined,
            likes: isSet(object.likes) ? Boolean(object.likes) : undefined,
            linkId: isSet(object.linkId) ? String(object.linkId) : undefined,
            locked: isSet(object.locked) ? Boolean(object.locked) : undefined,
            modNote: isSet(object.modNote) ? String(object.modNote) : undefined,
            modReasonBy: isSet(object.modReasonBy) ? String(object.modReasonBy) : undefined,
            modReasonTitle: isSet(object.modReasonTitle) ? String(object.modReasonTitle) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            noFollow: isSet(object.noFollow) ? Boolean(object.noFollow) : undefined,
            numReports: isSet(object.numReports) ? Number(object.numReports) : undefined,
            parentId: isSet(object.parentId) ? String(object.parentId) : undefined,
            permalink: isSet(object.permalink) ? String(object.permalink) : undefined,
            removalReason: isSet(object.removalReason) ? String(object.removalReason) : undefined,
            removed: isSet(object.removed) ? Boolean(object.removed) : undefined,
            replies: isSet(object.replies) ? String(object.replies) : undefined,
            reportReasons: globalThis.Array.isArray(object.reportReasons) ? [...object.reportReasons] : undefined,
            rteMode: isSet(object.rteMode) ? String(object.rteMode) : undefined,
            saved: isSet(object.saved) ? Boolean(object.saved) : undefined,
            score: isSet(object.score) ? Number(object.score) : undefined,
            scoreHidden: isSet(object.scoreHidden) ? Boolean(object.scoreHidden) : undefined,
            sendReplies: isSet(object.sendReplies) ? Boolean(object.sendReplies) : undefined,
            spam: isSet(object.spam) ? Boolean(object.spam) : undefined,
            stickied: isSet(object.stickied) ? Boolean(object.stickied) : undefined,
            subreddit: isSet(object.subreddit) ? String(object.subreddit) : undefined,
            subredditId: isSet(object.subredditId) ? String(object.subredditId) : undefined,
            subredditNamePrefixed: isSet(object.subredditNamePrefixed) ? String(object.subredditNamePrefixed) : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            topAwardedType: isSet(object.topAwardedType) ? String(object.topAwardedType) : undefined,
            totalAwardsReceived: isSet(object.totalAwardsReceived) ? Number(object.totalAwardsReceived) : undefined,
            treatmentTags: globalThis.Array.isArray(object?.treatmentTags)
                ? object.treatmentTags.map((e) => Any.fromJSON(e))
                : [],
            unrepliableReason: isSet(object.unrepliableReason) ? String(object.unrepliableReason) : undefined,
            ups: isSet(object.ups) ? Number(object.ups) : undefined,
            depth: isSet(object.depth) ? Number(object.depth) : undefined,
            linkTitle: isSet(object.linkTitle) ? String(object.linkTitle) : undefined,
            linkAuthor: isSet(object.linkAuthor) ? String(object.linkAuthor) : undefined,
            numComments: isSet(object.numComments) ? Number(object.numComments) : undefined,
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            linkPermalink: isSet(object.linkPermalink) ? String(object.linkPermalink) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            linkUrl: isSet(object.linkUrl) ? String(object.linkUrl) : undefined,
            selftext: isSet(object.selftext) ? String(object.selftext) : undefined,
            selftextHtml: isSet(object.selftextHtml) ? String(object.selftextHtml) : undefined,
            thumbnail: isSet(object.thumbnail) ? String(object.thumbnail) : undefined,
            thumbnailWidth: isSet(object.thumbnailWidth) ? Number(object.thumbnailWidth) : undefined,
            thumbnailHeight: isSet(object.thumbnailHeight) ? Number(object.thumbnailHeight) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            modPermissions: globalThis.Array.isArray(object?.modPermissions)
                ? object.modPermissions.map((e) => String(e))
                : [],
            count: isSet(object.count) ? Number(object.count) : undefined,
            children: globalThis.Array.isArray(object.children) ? [...object.children] : undefined,
            replyList: isSet(object.replyList) ? Listing.fromJSON(object.replyList) : undefined,
            hidden: isSet(object.hidden) ? Boolean(object.hidden) : undefined,
            linkFlairBackgroundColor: isSet(object.linkFlairBackgroundColor)
                ? String(object.linkFlairBackgroundColor)
                : undefined,
            linkFlairCssClass: isSet(object.linkFlairCssClass) ? String(object.linkFlairCssClass) : undefined,
            linkFlairRichtext: globalThis.Array.isArray(object?.linkFlairRichtext)
                ? object.linkFlairRichtext.map((e) => RedditObject_LinkFlairRichText.fromJSON(e))
                : [],
            linkFlairTemplateId: isSet(object.linkFlairTemplateId) ? String(object.linkFlairTemplateId) : undefined,
            linkFlairText: isSet(object.linkFlairText) ? String(object.linkFlairText) : undefined,
            linkFlairTextColor: isSet(object.linkFlairTextColor) ? String(object.linkFlairTextColor) : undefined,
            linkFlairType: isSet(object.linkFlairType) ? String(object.linkFlairType) : undefined,
            secureMedia: isSet(object.secureMedia) ? RedditObject_SecureMedia.fromJSON(object.secureMedia) : undefined,
            spoiler: isSet(object.spoiler) ? globalThis.Boolean(object.spoiler) : false,
            modReports: globalThis.Array.isArray(object?.modReports) ? object.modReports.map((e) => [...e]) : [],
            userReports: globalThis.Array.isArray(object?.userReports) ? object.userReports.map((e) => [...e]) : [],
            removedBy: isSet(object.removedBy) ? String(object.removedBy) : undefined,
            removedByCategory: isSet(object.removedByCategory) ? String(object.removedByCategory) : undefined,
            gallery: globalThis.Array.isArray(object?.gallery)
                ? object.gallery.map((e) => RedditObject_GalleryMedia.fromJSON(e))
                : [],
            pollData: isSet(object.pollData) ? PollData.fromJSON(object.pollData) : undefined,
            crosspostParent: isSet(object.crosspostParent) ? globalThis.String(object.crosspostParent) : undefined,
            daysLeft: isSet(object.daysLeft) ? globalThis.Number(object.daysLeft) : undefined,
            date: isSet(object.date) ? globalThis.Number(object.date) : undefined,
            note: isSet(object.note) ? globalThis.String(object.note) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allAwardings?.length) {
            obj.allAwardings = message.allAwardings.map((e) => Any.toJSON(e));
        }
        if (message.approved !== undefined) {
            obj.approved = message.approved;
        }
        if (message.approvedAtUtc !== undefined) {
            obj.approvedAtUtc = message.approvedAtUtc;
        }
        if (message.approvedBy !== undefined) {
            obj.approvedBy = message.approvedBy;
        }
        if (message.archived !== undefined) {
            obj.archived = message.archived;
        }
        if (message.associatedAward !== undefined) {
            obj.associatedAward = message.associatedAward;
        }
        if (message.author !== undefined) {
            obj.author = message.author;
        }
        if (message.authorFlairBackgroundColor !== undefined) {
            obj.authorFlairBackgroundColor = message.authorFlairBackgroundColor;
        }
        if (message.authorFlairCssClass !== undefined) {
            obj.authorFlairCssClass = message.authorFlairCssClass;
        }
        if (message.authorFlairRichtext?.length) {
            obj.authorFlairRichtext = message.authorFlairRichtext.map((e) => RedditObject_AuthorFlairRichText.toJSON(e));
        }
        if (message.authorFlairTemplateId !== undefined) {
            obj.authorFlairTemplateId = message.authorFlairTemplateId;
        }
        if (message.authorFlairText !== undefined) {
            obj.authorFlairText = message.authorFlairText;
        }
        if (message.authorFlairTextColor !== undefined) {
            obj.authorFlairTextColor = message.authorFlairTextColor;
        }
        if (message.authorFlairType !== undefined) {
            obj.authorFlairType = message.authorFlairType;
        }
        if (message.authorFullname !== undefined) {
            obj.authorFullname = message.authorFullname;
        }
        if (message.authorIsBlocked !== undefined) {
            obj.authorIsBlocked = message.authorIsBlocked;
        }
        if (message.authorPatreonFlair !== undefined) {
            obj.authorPatreonFlair = message.authorPatreonFlair;
        }
        if (message.authorPremium !== undefined) {
            obj.authorPremium = message.authorPremium;
        }
        if (message.awarders?.length) {
            obj.awarders = message.awarders;
        }
        if (message.bannedAtUtc !== undefined) {
            obj.bannedAtUtc = message.bannedAtUtc;
        }
        if (message.bannedBy !== undefined) {
            obj.bannedBy = message.bannedBy;
        }
        if (message.body !== undefined) {
            obj.body = message.body;
        }
        if (message.bodyHtml !== undefined) {
            obj.bodyHtml = message.bodyHtml;
        }
        if (message.canGild !== undefined) {
            obj.canGild = message.canGild;
        }
        if (message.canModPost !== undefined) {
            obj.canModPost = message.canModPost;
        }
        if (message.collapsed !== undefined) {
            obj.collapsed = message.collapsed;
        }
        if (message.collapsedBecauseCrowdControl !== undefined) {
            obj.collapsedBecauseCrowdControl = message.collapsedBecauseCrowdControl;
        }
        if (message.collapsedReason !== undefined) {
            obj.collapsedReason = message.collapsedReason;
        }
        if (message.collapsedReasonCode !== undefined) {
            obj.collapsedReasonCode = message.collapsedReasonCode;
        }
        if (message.commentType !== undefined) {
            obj.commentType = message.commentType;
        }
        if (message.controversiality !== undefined) {
            obj.controversiality = message.controversiality;
        }
        if (message.created !== undefined) {
            obj.created = message.created;
        }
        if (message.createdUtc !== undefined) {
            obj.createdUtc = message.createdUtc;
        }
        if (message.distinguished !== undefined) {
            obj.distinguished = message.distinguished;
        }
        if (message.downs !== undefined) {
            obj.downs = message.downs;
        }
        if (message.edited !== undefined) {
            obj.edited = message.edited;
        }
        if (message.gilded !== undefined) {
            obj.gilded = message.gilded;
        }
        if (message.gildings !== undefined) {
            obj.gildings = Any.toJSON(message.gildings);
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.ignoreReports !== undefined) {
            obj.ignoreReports = message.ignoreReports;
        }
        if (message.isSubmitter !== undefined) {
            obj.isSubmitter = message.isSubmitter;
        }
        if (message.likes !== undefined) {
            obj.likes = message.likes;
        }
        if (message.linkId !== undefined) {
            obj.linkId = message.linkId;
        }
        if (message.locked !== undefined) {
            obj.locked = message.locked;
        }
        if (message.modNote !== undefined) {
            obj.modNote = message.modNote;
        }
        if (message.modReasonBy !== undefined) {
            obj.modReasonBy = message.modReasonBy;
        }
        if (message.modReasonTitle !== undefined) {
            obj.modReasonTitle = message.modReasonTitle;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.noFollow !== undefined) {
            obj.noFollow = message.noFollow;
        }
        if (message.numReports !== undefined) {
            obj.numReports = message.numReports;
        }
        if (message.parentId !== undefined) {
            obj.parentId = message.parentId;
        }
        if (message.permalink !== undefined) {
            obj.permalink = message.permalink;
        }
        if (message.removalReason !== undefined) {
            obj.removalReason = message.removalReason;
        }
        if (message.removed !== undefined) {
            obj.removed = message.removed;
        }
        if (message.replies !== undefined) {
            obj.replies = message.replies;
        }
        if (message.reportReasons !== undefined) {
            obj.reportReasons = message.reportReasons;
        }
        if (message.rteMode !== undefined) {
            obj.rteMode = message.rteMode;
        }
        if (message.saved !== undefined) {
            obj.saved = message.saved;
        }
        if (message.score !== undefined) {
            obj.score = message.score;
        }
        if (message.scoreHidden !== undefined) {
            obj.scoreHidden = message.scoreHidden;
        }
        if (message.sendReplies !== undefined) {
            obj.sendReplies = message.sendReplies;
        }
        if (message.spam !== undefined) {
            obj.spam = message.spam;
        }
        if (message.stickied !== undefined) {
            obj.stickied = message.stickied;
        }
        if (message.subreddit !== undefined) {
            obj.subreddit = message.subreddit;
        }
        if (message.subredditId !== undefined) {
            obj.subredditId = message.subredditId;
        }
        if (message.subredditNamePrefixed !== undefined) {
            obj.subredditNamePrefixed = message.subredditNamePrefixed;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.topAwardedType !== undefined) {
            obj.topAwardedType = message.topAwardedType;
        }
        if (message.totalAwardsReceived !== undefined) {
            obj.totalAwardsReceived = message.totalAwardsReceived;
        }
        if (message.treatmentTags?.length) {
            obj.treatmentTags = message.treatmentTags.map((e) => Any.toJSON(e));
        }
        if (message.unrepliableReason !== undefined) {
            obj.unrepliableReason = message.unrepliableReason;
        }
        if (message.ups !== undefined) {
            obj.ups = message.ups;
        }
        if (message.depth !== undefined) {
            obj.depth = message.depth;
        }
        if (message.linkTitle !== undefined) {
            obj.linkTitle = message.linkTitle;
        }
        if (message.linkAuthor !== undefined) {
            obj.linkAuthor = message.linkAuthor;
        }
        if (message.numComments !== undefined) {
            obj.numComments = message.numComments;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.linkPermalink !== undefined) {
            obj.linkPermalink = message.linkPermalink;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.linkUrl !== undefined) {
            obj.linkUrl = message.linkUrl;
        }
        if (message.selftext !== undefined) {
            obj.selftext = message.selftext;
        }
        if (message.selftextHtml !== undefined) {
            obj.selftextHtml = message.selftextHtml;
        }
        if (message.thumbnail !== undefined) {
            obj.thumbnail = message.thumbnail;
        }
        if (message.thumbnailWidth !== undefined) {
            obj.thumbnailWidth = message.thumbnailWidth;
        }
        if (message.thumbnailHeight !== undefined) {
            obj.thumbnailHeight = message.thumbnailHeight;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.modPermissions?.length) {
            obj.modPermissions = message.modPermissions;
        }
        if (message.count !== undefined) {
            obj.count = message.count;
        }
        if (message.children !== undefined) {
            obj.children = message.children;
        }
        if (message.replyList !== undefined) {
            obj.replyList = Listing.toJSON(message.replyList);
        }
        if (message.hidden !== undefined) {
            obj.hidden = message.hidden;
        }
        if (message.linkFlairBackgroundColor !== undefined) {
            obj.linkFlairBackgroundColor = message.linkFlairBackgroundColor;
        }
        if (message.linkFlairCssClass !== undefined) {
            obj.linkFlairCssClass = message.linkFlairCssClass;
        }
        if (message.linkFlairRichtext?.length) {
            obj.linkFlairRichtext = message.linkFlairRichtext.map((e) => RedditObject_LinkFlairRichText.toJSON(e));
        }
        if (message.linkFlairTemplateId !== undefined) {
            obj.linkFlairTemplateId = message.linkFlairTemplateId;
        }
        if (message.linkFlairText !== undefined) {
            obj.linkFlairText = message.linkFlairText;
        }
        if (message.linkFlairTextColor !== undefined) {
            obj.linkFlairTextColor = message.linkFlairTextColor;
        }
        if (message.linkFlairType !== undefined) {
            obj.linkFlairType = message.linkFlairType;
        }
        if (message.secureMedia !== undefined) {
            obj.secureMedia = RedditObject_SecureMedia.toJSON(message.secureMedia);
        }
        if (message.spoiler !== false) {
            obj.spoiler = message.spoiler;
        }
        if (message.modReports?.length) {
            obj.modReports = message.modReports;
        }
        if (message.userReports?.length) {
            obj.userReports = message.userReports;
        }
        if (message.removedBy !== undefined) {
            obj.removedBy = message.removedBy;
        }
        if (message.removedByCategory !== undefined) {
            obj.removedByCategory = message.removedByCategory;
        }
        if (message.gallery?.length) {
            obj.gallery = message.gallery.map((e) => RedditObject_GalleryMedia.toJSON(e));
        }
        if (message.pollData !== undefined) {
            obj.pollData = PollData.toJSON(message.pollData);
        }
        if (message.crosspostParent !== undefined) {
            obj.crosspostParent = message.crosspostParent;
        }
        if (message.daysLeft !== undefined) {
            obj.daysLeft = Math.round(message.daysLeft);
        }
        if (message.date !== undefined) {
            obj.date = Math.round(message.date);
        }
        if (message.note !== undefined) {
            obj.note = message.note;
        }
        return obj;
    },
    create(base) {
        return RedditObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject();
        message.allAwardings = object.allAwardings?.map((e) => Any.fromPartial(e)) || [];
        message.approved = object.approved ?? undefined;
        message.approvedAtUtc = object.approvedAtUtc ?? undefined;
        message.approvedBy = object.approvedBy ?? undefined;
        message.archived = object.archived ?? undefined;
        message.associatedAward = object.associatedAward ?? undefined;
        message.author = object.author ?? undefined;
        message.authorFlairBackgroundColor = object.authorFlairBackgroundColor ?? undefined;
        message.authorFlairCssClass = object.authorFlairCssClass ?? undefined;
        message.authorFlairRichtext =
            object.authorFlairRichtext?.map((e) => RedditObject_AuthorFlairRichText.fromPartial(e)) || [];
        message.authorFlairTemplateId = object.authorFlairTemplateId ?? undefined;
        message.authorFlairText = object.authorFlairText ?? undefined;
        message.authorFlairTextColor = object.authorFlairTextColor ?? undefined;
        message.authorFlairType = object.authorFlairType ?? undefined;
        message.authorFullname = object.authorFullname ?? undefined;
        message.authorIsBlocked = object.authorIsBlocked ?? undefined;
        message.authorPatreonFlair = object.authorPatreonFlair ?? undefined;
        message.authorPremium = object.authorPremium ?? undefined;
        message.awarders = object.awarders?.map((e) => e) || [];
        message.bannedAtUtc = object.bannedAtUtc ?? undefined;
        message.bannedBy = object.bannedBy ?? undefined;
        message.body = object.body ?? undefined;
        message.bodyHtml = object.bodyHtml ?? undefined;
        message.canGild = object.canGild ?? undefined;
        message.canModPost = object.canModPost ?? undefined;
        message.collapsed = object.collapsed ?? undefined;
        message.collapsedBecauseCrowdControl = object.collapsedBecauseCrowdControl ?? undefined;
        message.collapsedReason = object.collapsedReason ?? undefined;
        message.collapsedReasonCode = object.collapsedReasonCode ?? undefined;
        message.commentType = object.commentType ?? undefined;
        message.controversiality = object.controversiality ?? undefined;
        message.created = object.created ?? undefined;
        message.createdUtc = object.createdUtc ?? undefined;
        message.distinguished = object.distinguished ?? undefined;
        message.downs = object.downs ?? undefined;
        message.edited = object.edited ?? undefined;
        message.gilded = object.gilded ?? undefined;
        message.gildings = (object.gildings !== undefined && object.gildings !== null)
            ? Any.fromPartial(object.gildings)
            : undefined;
        message.id = object.id ?? undefined;
        message.ignoreReports = object.ignoreReports ?? undefined;
        message.isSubmitter = object.isSubmitter ?? undefined;
        message.likes = object.likes ?? undefined;
        message.linkId = object.linkId ?? undefined;
        message.locked = object.locked ?? undefined;
        message.modNote = object.modNote ?? undefined;
        message.modReasonBy = object.modReasonBy ?? undefined;
        message.modReasonTitle = object.modReasonTitle ?? undefined;
        message.name = object.name ?? undefined;
        message.noFollow = object.noFollow ?? undefined;
        message.numReports = object.numReports ?? undefined;
        message.parentId = object.parentId ?? undefined;
        message.permalink = object.permalink ?? undefined;
        message.removalReason = object.removalReason ?? undefined;
        message.removed = object.removed ?? undefined;
        message.replies = object.replies ?? undefined;
        message.reportReasons = object.reportReasons ?? undefined;
        message.rteMode = object.rteMode ?? undefined;
        message.saved = object.saved ?? undefined;
        message.score = object.score ?? undefined;
        message.scoreHidden = object.scoreHidden ?? undefined;
        message.sendReplies = object.sendReplies ?? undefined;
        message.spam = object.spam ?? undefined;
        message.stickied = object.stickied ?? undefined;
        message.subreddit = object.subreddit ?? undefined;
        message.subredditId = object.subredditId ?? undefined;
        message.subredditNamePrefixed = object.subredditNamePrefixed ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.topAwardedType = object.topAwardedType ?? undefined;
        message.totalAwardsReceived = object.totalAwardsReceived ?? undefined;
        message.treatmentTags = object.treatmentTags?.map((e) => Any.fromPartial(e)) || [];
        message.unrepliableReason = object.unrepliableReason ?? undefined;
        message.ups = object.ups ?? undefined;
        message.depth = object.depth ?? undefined;
        message.linkTitle = object.linkTitle ?? undefined;
        message.linkAuthor = object.linkAuthor ?? undefined;
        message.numComments = object.numComments ?? undefined;
        message.over18 = object.over18 ?? undefined;
        message.linkPermalink = object.linkPermalink ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.linkUrl = object.linkUrl ?? undefined;
        message.selftext = object.selftext ?? undefined;
        message.selftextHtml = object.selftextHtml ?? undefined;
        message.thumbnail = object.thumbnail ?? undefined;
        message.thumbnailWidth = object.thumbnailWidth ?? undefined;
        message.thumbnailHeight = object.thumbnailHeight ?? undefined;
        message.title = object.title ?? undefined;
        message.url = object.url ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.modPermissions = object.modPermissions?.map((e) => e) || [];
        message.count = object.count ?? undefined;
        message.children = object.children ?? undefined;
        message.replyList = (object.replyList !== undefined && object.replyList !== null)
            ? Listing.fromPartial(object.replyList)
            : undefined;
        message.hidden = object.hidden ?? undefined;
        message.linkFlairBackgroundColor = object.linkFlairBackgroundColor ?? undefined;
        message.linkFlairCssClass = object.linkFlairCssClass ?? undefined;
        message.linkFlairRichtext = object.linkFlairRichtext?.map((e) => RedditObject_LinkFlairRichText.fromPartial(e)) ||
            [];
        message.linkFlairTemplateId = object.linkFlairTemplateId ?? undefined;
        message.linkFlairText = object.linkFlairText ?? undefined;
        message.linkFlairTextColor = object.linkFlairTextColor ?? undefined;
        message.linkFlairType = object.linkFlairType ?? undefined;
        message.secureMedia = (object.secureMedia !== undefined && object.secureMedia !== null)
            ? RedditObject_SecureMedia.fromPartial(object.secureMedia)
            : undefined;
        message.spoiler = object.spoiler ?? false;
        message.modReports = object.modReports?.map((e) => e) || [];
        message.userReports = object.userReports?.map((e) => e) || [];
        message.removedBy = object.removedBy ?? undefined;
        message.removedByCategory = object.removedByCategory ?? undefined;
        message.gallery = object.gallery?.map((e) => RedditObject_GalleryMedia.fromPartial(e)) || [];
        message.pollData = (object.pollData !== undefined && object.pollData !== null)
            ? PollData.fromPartial(object.pollData)
            : undefined;
        message.crosspostParent = object.crosspostParent ?? undefined;
        message.daysLeft = object.daysLeft ?? undefined;
        message.date = object.date ?? undefined;
        message.note = object.note ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(RedditObject.$type, RedditObject);
function createBaseRedditObject_OEmbed() {
    return {
        type: "",
        title: undefined,
        providerName: undefined,
        providerUrl: undefined,
        version: "",
        thumbnailWidth: undefined,
        thumbnailHeight: undefined,
        thumbnailUrl: undefined,
        html: "",
        height: undefined,
        width: undefined,
        authorUrl: undefined,
        authorName: undefined,
    };
}
export const RedditObject_OEmbed = {
    $type: "devvit.plugin.redditapi.common.RedditObject.OEmbed",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.title !== undefined) {
            writer.uint32(18).string(message.title);
        }
        if (message.providerName !== undefined) {
            writer.uint32(26).string(message.providerName);
        }
        if (message.providerUrl !== undefined) {
            writer.uint32(34).string(message.providerUrl);
        }
        if (message.version !== "") {
            writer.uint32(42).string(message.version);
        }
        if (message.thumbnailWidth !== undefined) {
            Int32Value.encode({ value: message.thumbnailWidth }, writer.uint32(50).fork()).ldelim();
        }
        if (message.thumbnailHeight !== undefined) {
            Int32Value.encode({ value: message.thumbnailHeight }, writer.uint32(58).fork()).ldelim();
        }
        if (message.thumbnailUrl !== undefined) {
            writer.uint32(66).string(message.thumbnailUrl);
        }
        if (message.html !== "") {
            writer.uint32(74).string(message.html);
        }
        if (message.height !== undefined) {
            Int32Value.encode({ value: message.height }, writer.uint32(82).fork()).ldelim();
        }
        if (message.width !== undefined) {
            Int32Value.encode({ value: message.width }, writer.uint32(90).fork()).ldelim();
        }
        if (message.authorUrl !== undefined) {
            writer.uint32(98).string(message.authorUrl);
        }
        if (message.authorName !== undefined) {
            writer.uint32(106).string(message.authorName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject_OEmbed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.providerName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.providerUrl = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.version = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.thumbnailWidth = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.thumbnailHeight = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.thumbnailUrl = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.html = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.height = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.width = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.authorUrl = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.authorName = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            title: isSet(object.title) ? globalThis.String(object.title) : undefined,
            providerName: isSet(object.providerName) ? globalThis.String(object.providerName) : undefined,
            providerUrl: isSet(object.providerUrl) ? globalThis.String(object.providerUrl) : undefined,
            version: isSet(object.version) ? globalThis.String(object.version) : "",
            thumbnailWidth: isSet(object.thumbnailWidth) ? Number(object.thumbnailWidth) : undefined,
            thumbnailHeight: isSet(object.thumbnailHeight) ? Number(object.thumbnailHeight) : undefined,
            thumbnailUrl: isSet(object.thumbnailUrl) ? globalThis.String(object.thumbnailUrl) : undefined,
            html: isSet(object.html) ? globalThis.String(object.html) : "",
            height: isSet(object.height) ? Number(object.height) : undefined,
            width: isSet(object.width) ? Number(object.width) : undefined,
            authorUrl: isSet(object.authorUrl) ? globalThis.String(object.authorUrl) : undefined,
            authorName: isSet(object.authorName) ? globalThis.String(object.authorName) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.providerName !== undefined) {
            obj.providerName = message.providerName;
        }
        if (message.providerUrl !== undefined) {
            obj.providerUrl = message.providerUrl;
        }
        if (message.version !== "") {
            obj.version = message.version;
        }
        if (message.thumbnailWidth !== undefined) {
            obj.thumbnailWidth = message.thumbnailWidth;
        }
        if (message.thumbnailHeight !== undefined) {
            obj.thumbnailHeight = message.thumbnailHeight;
        }
        if (message.thumbnailUrl !== undefined) {
            obj.thumbnailUrl = message.thumbnailUrl;
        }
        if (message.html !== "") {
            obj.html = message.html;
        }
        if (message.height !== undefined) {
            obj.height = message.height;
        }
        if (message.width !== undefined) {
            obj.width = message.width;
        }
        if (message.authorUrl !== undefined) {
            obj.authorUrl = message.authorUrl;
        }
        if (message.authorName !== undefined) {
            obj.authorName = message.authorName;
        }
        return obj;
    },
    create(base) {
        return RedditObject_OEmbed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject_OEmbed();
        message.type = object.type ?? "";
        message.title = object.title ?? undefined;
        message.providerName = object.providerName ?? undefined;
        message.providerUrl = object.providerUrl ?? undefined;
        message.version = object.version ?? "";
        message.thumbnailWidth = object.thumbnailWidth ?? undefined;
        message.thumbnailHeight = object.thumbnailHeight ?? undefined;
        message.thumbnailUrl = object.thumbnailUrl ?? undefined;
        message.html = object.html ?? "";
        message.height = object.height ?? undefined;
        message.width = object.width ?? undefined;
        message.authorUrl = object.authorUrl ?? undefined;
        message.authorName = object.authorName ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(RedditObject_OEmbed.$type, RedditObject_OEmbed);
function createBaseRedditObject_RedditVideo() {
    return {
        bitrateKbps: undefined,
        dashUrl: undefined,
        duration: undefined,
        fallbackUrl: undefined,
        height: undefined,
        hlsUrl: undefined,
        isGif: undefined,
        scrubberMediaUrl: undefined,
        transcodingStatus: undefined,
        width: undefined,
    };
}
export const RedditObject_RedditVideo = {
    $type: "devvit.plugin.redditapi.common.RedditObject.RedditVideo",
    encode(message, writer = _m0.Writer.create()) {
        if (message.bitrateKbps !== undefined) {
            Int32Value.encode({ value: message.bitrateKbps }, writer.uint32(10).fork()).ldelim();
        }
        if (message.dashUrl !== undefined) {
            StringValue.encode({ value: message.dashUrl }, writer.uint32(18).fork()).ldelim();
        }
        if (message.duration !== undefined) {
            Int32Value.encode({ value: message.duration }, writer.uint32(26).fork()).ldelim();
        }
        if (message.fallbackUrl !== undefined) {
            StringValue.encode({ value: message.fallbackUrl }, writer.uint32(34).fork()).ldelim();
        }
        if (message.height !== undefined) {
            Int32Value.encode({ value: message.height }, writer.uint32(42).fork()).ldelim();
        }
        if (message.hlsUrl !== undefined) {
            StringValue.encode({ value: message.hlsUrl }, writer.uint32(50).fork()).ldelim();
        }
        if (message.isGif !== undefined) {
            BoolValue.encode({ value: message.isGif }, writer.uint32(58).fork()).ldelim();
        }
        if (message.scrubberMediaUrl !== undefined) {
            StringValue.encode({ value: message.scrubberMediaUrl }, writer.uint32(66).fork()).ldelim();
        }
        if (message.transcodingStatus !== undefined) {
            StringValue.encode({ value: message.transcodingStatus }, writer.uint32(74).fork()).ldelim();
        }
        if (message.width !== undefined) {
            Int32Value.encode({ value: message.width }, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject_RedditVideo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.bitrateKbps = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.dashUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.duration = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.fallbackUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.height = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.hlsUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.isGif = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.scrubberMediaUrl = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.transcodingStatus = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.width = Int32Value.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            bitrateKbps: isSet(object.bitrateKbps) ? Number(object.bitrateKbps) : undefined,
            dashUrl: isSet(object.dashUrl) ? String(object.dashUrl) : undefined,
            duration: isSet(object.duration) ? Number(object.duration) : undefined,
            fallbackUrl: isSet(object.fallbackUrl) ? String(object.fallbackUrl) : undefined,
            height: isSet(object.height) ? Number(object.height) : undefined,
            hlsUrl: isSet(object.hlsUrl) ? String(object.hlsUrl) : undefined,
            isGif: isSet(object.isGif) ? Boolean(object.isGif) : undefined,
            scrubberMediaUrl: isSet(object.scrubberMediaUrl) ? String(object.scrubberMediaUrl) : undefined,
            transcodingStatus: isSet(object.transcodingStatus) ? String(object.transcodingStatus) : undefined,
            width: isSet(object.width) ? Number(object.width) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.bitrateKbps !== undefined) {
            obj.bitrateKbps = message.bitrateKbps;
        }
        if (message.dashUrl !== undefined) {
            obj.dashUrl = message.dashUrl;
        }
        if (message.duration !== undefined) {
            obj.duration = message.duration;
        }
        if (message.fallbackUrl !== undefined) {
            obj.fallbackUrl = message.fallbackUrl;
        }
        if (message.height !== undefined) {
            obj.height = message.height;
        }
        if (message.hlsUrl !== undefined) {
            obj.hlsUrl = message.hlsUrl;
        }
        if (message.isGif !== undefined) {
            obj.isGif = message.isGif;
        }
        if (message.scrubberMediaUrl !== undefined) {
            obj.scrubberMediaUrl = message.scrubberMediaUrl;
        }
        if (message.transcodingStatus !== undefined) {
            obj.transcodingStatus = message.transcodingStatus;
        }
        if (message.width !== undefined) {
            obj.width = message.width;
        }
        return obj;
    },
    create(base) {
        return RedditObject_RedditVideo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject_RedditVideo();
        message.bitrateKbps = object.bitrateKbps ?? undefined;
        message.dashUrl = object.dashUrl ?? undefined;
        message.duration = object.duration ?? undefined;
        message.fallbackUrl = object.fallbackUrl ?? undefined;
        message.height = object.height ?? undefined;
        message.hlsUrl = object.hlsUrl ?? undefined;
        message.isGif = object.isGif ?? undefined;
        message.scrubberMediaUrl = object.scrubberMediaUrl ?? undefined;
        message.transcodingStatus = object.transcodingStatus ?? undefined;
        message.width = object.width ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(RedditObject_RedditVideo.$type, RedditObject_RedditVideo);
function createBaseRedditObject_AuthorFlairRichText() {
    return { e: undefined, t: undefined, a: undefined, u: undefined };
}
export const RedditObject_AuthorFlairRichText = {
    $type: "devvit.plugin.redditapi.common.RedditObject.AuthorFlairRichText",
    encode(message, writer = _m0.Writer.create()) {
        if (message.e !== undefined) {
            StringValue.encode({ value: message.e }, writer.uint32(10).fork()).ldelim();
        }
        if (message.t !== undefined) {
            StringValue.encode({ value: message.t }, writer.uint32(18).fork()).ldelim();
        }
        if (message.a !== undefined) {
            StringValue.encode({ value: message.a }, writer.uint32(26).fork()).ldelim();
        }
        if (message.u !== undefined) {
            StringValue.encode({ value: message.u }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject_AuthorFlairRichText();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.e = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.t = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.a = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.u = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            e: isSet(object.e) ? String(object.e) : undefined,
            t: isSet(object.t) ? String(object.t) : undefined,
            a: isSet(object.a) ? String(object.a) : undefined,
            u: isSet(object.u) ? String(object.u) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.e !== undefined) {
            obj.e = message.e;
        }
        if (message.t !== undefined) {
            obj.t = message.t;
        }
        if (message.a !== undefined) {
            obj.a = message.a;
        }
        if (message.u !== undefined) {
            obj.u = message.u;
        }
        return obj;
    },
    create(base) {
        return RedditObject_AuthorFlairRichText.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject_AuthorFlairRichText();
        message.e = object.e ?? undefined;
        message.t = object.t ?? undefined;
        message.a = object.a ?? undefined;
        message.u = object.u ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(RedditObject_AuthorFlairRichText.$type, RedditObject_AuthorFlairRichText);
function createBaseRedditObject_LinkFlairRichText() {
    return { e: undefined, t: undefined, a: undefined, u: undefined };
}
export const RedditObject_LinkFlairRichText = {
    $type: "devvit.plugin.redditapi.common.RedditObject.LinkFlairRichText",
    encode(message, writer = _m0.Writer.create()) {
        if (message.e !== undefined) {
            StringValue.encode({ value: message.e }, writer.uint32(10).fork()).ldelim();
        }
        if (message.t !== undefined) {
            StringValue.encode({ value: message.t }, writer.uint32(18).fork()).ldelim();
        }
        if (message.a !== undefined) {
            StringValue.encode({ value: message.a }, writer.uint32(26).fork()).ldelim();
        }
        if (message.u !== undefined) {
            StringValue.encode({ value: message.u }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject_LinkFlairRichText();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.e = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.t = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.a = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.u = StringValue.decode(reader, reader.uint32()).value;
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            e: isSet(object.e) ? String(object.e) : undefined,
            t: isSet(object.t) ? String(object.t) : undefined,
            a: isSet(object.a) ? String(object.a) : undefined,
            u: isSet(object.u) ? String(object.u) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.e !== undefined) {
            obj.e = message.e;
        }
        if (message.t !== undefined) {
            obj.t = message.t;
        }
        if (message.a !== undefined) {
            obj.a = message.a;
        }
        if (message.u !== undefined) {
            obj.u = message.u;
        }
        return obj;
    },
    create(base) {
        return RedditObject_LinkFlairRichText.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject_LinkFlairRichText();
        message.e = object.e ?? undefined;
        message.t = object.t ?? undefined;
        message.a = object.a ?? undefined;
        message.u = object.u ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(RedditObject_LinkFlairRichText.$type, RedditObject_LinkFlairRichText);
function createBaseRedditObject_SecureMedia() {
    return { type: "", oembed: undefined, redditVideo: undefined };
}
export const RedditObject_SecureMedia = {
    $type: "devvit.plugin.redditapi.common.RedditObject.SecureMedia",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.oembed !== undefined) {
            RedditObject_OEmbed.encode(message.oembed, writer.uint32(18).fork()).ldelim();
        }
        if (message.redditVideo !== undefined) {
            RedditObject_RedditVideo.encode(message.redditVideo, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject_SecureMedia();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.oembed = RedditObject_OEmbed.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.redditVideo = RedditObject_RedditVideo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            oembed: isSet(object.oembed) ? RedditObject_OEmbed.fromJSON(object.oembed) : undefined,
            redditVideo: isSet(object.redditVideo) ? RedditObject_RedditVideo.fromJSON(object.redditVideo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.oembed !== undefined) {
            obj.oembed = RedditObject_OEmbed.toJSON(message.oembed);
        }
        if (message.redditVideo !== undefined) {
            obj.redditVideo = RedditObject_RedditVideo.toJSON(message.redditVideo);
        }
        return obj;
    },
    create(base) {
        return RedditObject_SecureMedia.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject_SecureMedia();
        message.type = object.type ?? "";
        message.oembed = (object.oembed !== undefined && object.oembed !== null)
            ? RedditObject_OEmbed.fromPartial(object.oembed)
            : undefined;
        message.redditVideo = (object.redditVideo !== undefined && object.redditVideo !== null)
            ? RedditObject_RedditVideo.fromPartial(object.redditVideo)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(RedditObject_SecureMedia.$type, RedditObject_SecureMedia);
function createBaseRedditObject_GalleryMedia() {
    return { url: "", width: 0, height: 0, status: 0 };
}
export const RedditObject_GalleryMedia = {
    $type: "devvit.plugin.redditapi.common.RedditObject.GalleryMedia",
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.width !== 0) {
            writer.uint32(16).int64(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(24).int64(message.height);
        }
        if (message.status !== 0) {
            writer.uint32(32).int32(message.status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedditObject_GalleryMedia();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.width = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.height = longToNumber(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.status = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            status: isSet(object.status) ? galleryMediaStatusFromJSON(object.status) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.status !== 0) {
            obj.status = galleryMediaStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return RedditObject_GalleryMedia.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedditObject_GalleryMedia();
        message.url = object.url ?? "";
        message.width = object.width ?? 0;
        message.height = object.height ?? 0;
        message.status = object.status ?? 0;
        return message;
    },
};
messageTypeRegistry.set(RedditObject_GalleryMedia.$type, RedditObject_GalleryMedia);
function createBasePollOption() {
    return { id: "", text: "", voteCount: 0 };
}
export const PollOption = {
    $type: "devvit.plugin.redditapi.common.PollOption",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.voteCount !== 0) {
            writer.uint32(24).int64(message.voteCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePollOption();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.voteCount = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            voteCount: isSet(object.voteCount) ? globalThis.Number(object.voteCount) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.voteCount !== 0) {
            obj.voteCount = Math.round(message.voteCount);
        }
        return obj;
    },
    create(base) {
        return PollOption.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePollOption();
        message.id = object.id ?? "";
        message.text = object.text ?? "";
        message.voteCount = object.voteCount ?? 0;
        return message;
    },
};
messageTypeRegistry.set(PollOption.$type, PollOption);
function createBasePollData() {
    return { options: [], totalVoteCount: 0, userSelection: undefined, votingEndTimestamp: 0 };
}
export const PollData = {
    $type: "devvit.plugin.redditapi.common.PollData",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.options) {
            PollOption.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.totalVoteCount !== 0) {
            writer.uint32(16).int64(message.totalVoteCount);
        }
        if (message.userSelection !== undefined) {
            writer.uint32(26).string(message.userSelection);
        }
        if (message.votingEndTimestamp !== 0) {
            writer.uint32(32).int64(message.votingEndTimestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePollData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.options.push(PollOption.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.totalVoteCount = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.userSelection = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.votingEndTimestamp = longToNumber(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            options: globalThis.Array.isArray(object?.options) ? object.options.map((e) => PollOption.fromJSON(e)) : [],
            totalVoteCount: isSet(object.totalVoteCount) ? globalThis.Number(object.totalVoteCount) : 0,
            userSelection: isSet(object.userSelection) ? globalThis.String(object.userSelection) : undefined,
            votingEndTimestamp: isSet(object.votingEndTimestamp) ? globalThis.Number(object.votingEndTimestamp) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.options?.length) {
            obj.options = message.options.map((e) => PollOption.toJSON(e));
        }
        if (message.totalVoteCount !== 0) {
            obj.totalVoteCount = Math.round(message.totalVoteCount);
        }
        if (message.userSelection !== undefined) {
            obj.userSelection = message.userSelection;
        }
        if (message.votingEndTimestamp !== 0) {
            obj.votingEndTimestamp = Math.round(message.votingEndTimestamp);
        }
        return obj;
    },
    create(base) {
        return PollData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePollData();
        message.options = object.options?.map((e) => PollOption.fromPartial(e)) || [];
        message.totalVoteCount = object.totalVoteCount ?? 0;
        message.userSelection = object.userSelection ?? undefined;
        message.votingEndTimestamp = object.votingEndTimestamp ?? 0;
        return message;
    },
};
messageTypeRegistry.set(PollData.$type, PollData);
function createBaseSubredditObject() {
    return {
        defaultSet: undefined,
        userIsContributor: undefined,
        bannerImg: undefined,
        restrictPosting: undefined,
        userIsBanned: undefined,
        freeFormReports: undefined,
        communityIcon: undefined,
        showMedia: undefined,
        iconColor: undefined,
        displayName: undefined,
        headerImg: undefined,
        title: undefined,
        coins: undefined,
        previousNames: [],
        over18: undefined,
        iconSize: [],
        primaryColor: undefined,
        iconImg: undefined,
        description: undefined,
        submitLinkLabel: undefined,
        headerSize: undefined,
        restrictCommenting: undefined,
        subscribers: undefined,
        submitTextLabel: undefined,
        isDefaultIcon: undefined,
        linkFlairPosition: undefined,
        displayNamePrefixed: undefined,
        keyColor: undefined,
        name: undefined,
        isDefaultBanner: undefined,
        url: undefined,
        quarantine: undefined,
        bannerSize: [],
        userIsModerator: undefined,
        acceptFollowers: undefined,
        publicDescription: undefined,
        linkFlairEnabled: undefined,
        disableContributorRequests: undefined,
        subredditType: undefined,
        userIsSubscriber: undefined,
        publicDescriptionHtml: undefined,
        id: undefined,
        userIsMuted: false,
    };
}
export const SubredditObject = {
    $type: "devvit.plugin.redditapi.common.SubredditObject",
    encode(message, writer = _m0.Writer.create()) {
        if (message.defaultSet !== undefined) {
            BoolValue.encode({ value: message.defaultSet }, writer.uint32(10).fork()).ldelim();
        }
        if (message.userIsContributor !== undefined) {
            BoolValue.encode({ value: message.userIsContributor }, writer.uint32(18).fork()).ldelim();
        }
        if (message.bannerImg !== undefined) {
            StringValue.encode({ value: message.bannerImg }, writer.uint32(26).fork()).ldelim();
        }
        if (message.restrictPosting !== undefined) {
            BoolValue.encode({ value: message.restrictPosting }, writer.uint32(34).fork()).ldelim();
        }
        if (message.userIsBanned !== undefined) {
            BoolValue.encode({ value: message.userIsBanned }, writer.uint32(42).fork()).ldelim();
        }
        if (message.freeFormReports !== undefined) {
            BoolValue.encode({ value: message.freeFormReports }, writer.uint32(50).fork()).ldelim();
        }
        if (message.communityIcon !== undefined) {
            StringValue.encode({ value: message.communityIcon }, writer.uint32(58).fork()).ldelim();
        }
        if (message.showMedia !== undefined) {
            BoolValue.encode({ value: message.showMedia }, writer.uint32(66).fork()).ldelim();
        }
        if (message.iconColor !== undefined) {
            StringValue.encode({ value: message.iconColor }, writer.uint32(74).fork()).ldelim();
        }
        if (message.displayName !== undefined) {
            StringValue.encode({ value: message.displayName }, writer.uint32(90).fork()).ldelim();
        }
        if (message.headerImg !== undefined) {
            StringValue.encode({ value: message.headerImg }, writer.uint32(98).fork()).ldelim();
        }
        if (message.title !== undefined) {
            StringValue.encode({ value: message.title }, writer.uint32(106).fork()).ldelim();
        }
        if (message.coins !== undefined) {
            Int64Value.encode({ value: message.coins }, writer.uint32(114).fork()).ldelim();
        }
        for (const v of message.previousNames) {
            StringValue.encode({ value: v }, writer.uint32(122).fork()).ldelim();
        }
        if (message.over18 !== undefined) {
            BoolValue.encode({ value: message.over18 }, writer.uint32(130).fork()).ldelim();
        }
        for (const v of message.iconSize) {
            Int32Value.encode({ value: v }, writer.uint32(138).fork()).ldelim();
        }
        if (message.primaryColor !== undefined) {
            StringValue.encode({ value: message.primaryColor }, writer.uint32(146).fork()).ldelim();
        }
        if (message.iconImg !== undefined) {
            StringValue.encode({ value: message.iconImg }, writer.uint32(154).fork()).ldelim();
        }
        if (message.description !== undefined) {
            StringValue.encode({ value: message.description }, writer.uint32(162).fork()).ldelim();
        }
        if (message.submitLinkLabel !== undefined) {
            StringValue.encode({ value: message.submitLinkLabel }, writer.uint32(170).fork()).ldelim();
        }
        if (message.headerSize !== undefined) {
            StringValue.encode({ value: message.headerSize }, writer.uint32(178).fork()).ldelim();
        }
        if (message.restrictCommenting !== undefined) {
            BoolValue.encode({ value: message.restrictCommenting }, writer.uint32(186).fork()).ldelim();
        }
        if (message.subscribers !== undefined) {
            Int64Value.encode({ value: message.subscribers }, writer.uint32(194).fork()).ldelim();
        }
        if (message.submitTextLabel !== undefined) {
            StringValue.encode({ value: message.submitTextLabel }, writer.uint32(202).fork()).ldelim();
        }
        if (message.isDefaultIcon !== undefined) {
            BoolValue.encode({ value: message.isDefaultIcon }, writer.uint32(210).fork()).ldelim();
        }
        if (message.linkFlairPosition !== undefined) {
            StringValue.encode({ value: message.linkFlairPosition }, writer.uint32(218).fork()).ldelim();
        }
        if (message.displayNamePrefixed !== undefined) {
            StringValue.encode({ value: message.displayNamePrefixed }, writer.uint32(226).fork()).ldelim();
        }
        if (message.keyColor !== undefined) {
            StringValue.encode({ value: message.keyColor }, writer.uint32(234).fork()).ldelim();
        }
        if (message.name !== undefined) {
            StringValue.encode({ value: message.name }, writer.uint32(242).fork()).ldelim();
        }
        if (message.isDefaultBanner !== undefined) {
            BoolValue.encode({ value: message.isDefaultBanner }, writer.uint32(250).fork()).ldelim();
        }
        if (message.url !== undefined) {
            StringValue.encode({ value: message.url }, writer.uint32(258).fork()).ldelim();
        }
        if (message.quarantine !== undefined) {
            BoolValue.encode({ value: message.quarantine }, writer.uint32(266).fork()).ldelim();
        }
        for (const v of message.bannerSize) {
            Int32Value.encode({ value: v }, writer.uint32(274).fork()).ldelim();
        }
        if (message.userIsModerator !== undefined) {
            BoolValue.encode({ value: message.userIsModerator }, writer.uint32(282).fork()).ldelim();
        }
        if (message.acceptFollowers !== undefined) {
            BoolValue.encode({ value: message.acceptFollowers }, writer.uint32(290).fork()).ldelim();
        }
        if (message.publicDescription !== undefined) {
            StringValue.encode({ value: message.publicDescription }, writer.uint32(298).fork()).ldelim();
        }
        if (message.linkFlairEnabled !== undefined) {
            BoolValue.encode({ value: message.linkFlairEnabled }, writer.uint32(306).fork()).ldelim();
        }
        if (message.disableContributorRequests !== undefined) {
            BoolValue.encode({ value: message.disableContributorRequests }, writer.uint32(314).fork()).ldelim();
        }
        if (message.subredditType !== undefined) {
            StringValue.encode({ value: message.subredditType }, writer.uint32(322).fork()).ldelim();
        }
        if (message.userIsSubscriber !== undefined) {
            BoolValue.encode({ value: message.userIsSubscriber }, writer.uint32(330).fork()).ldelim();
        }
        if (message.publicDescriptionHtml !== undefined) {
            StringValue.encode({ value: message.publicDescriptionHtml }, writer.uint32(338).fork()).ldelim();
        }
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(346).fork()).ldelim();
        }
        if (message.userIsMuted !== false) {
            writer.uint32(352).bool(message.userIsMuted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSubredditObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.defaultSet = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.userIsContributor = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.bannerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.restrictPosting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.userIsBanned = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.freeFormReports = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.communityIcon = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.showMedia = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.iconColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.displayName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.headerImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.title = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.coins = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.previousNames.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.over18 = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.iconSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.primaryColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.iconImg = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.description = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.submitLinkLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.headerSize = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.restrictCommenting = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.subscribers = Int64Value.decode(reader, reader.uint32()).value;
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.submitTextLabel = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.isDefaultIcon = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.linkFlairPosition = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.displayNamePrefixed = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.keyColor = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.name = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.isDefaultBanner = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.url = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.quarantine = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.bannerSize.push(Int32Value.decode(reader, reader.uint32()).value);
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.userIsModerator = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.acceptFollowers = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.publicDescription = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.linkFlairEnabled = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.disableContributorRequests = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.subredditType = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.userIsSubscriber = BoolValue.decode(reader, reader.uint32()).value;
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.publicDescriptionHtml = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 44:
                    if (tag !== 352) {
                        break;
                    }
                    message.userIsMuted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            defaultSet: isSet(object.defaultSet) ? Boolean(object.defaultSet) : undefined,
            userIsContributor: isSet(object.userIsContributor) ? Boolean(object.userIsContributor) : undefined,
            bannerImg: isSet(object.bannerImg) ? String(object.bannerImg) : undefined,
            restrictPosting: isSet(object.restrictPosting) ? Boolean(object.restrictPosting) : undefined,
            userIsBanned: isSet(object.userIsBanned) ? Boolean(object.userIsBanned) : undefined,
            freeFormReports: isSet(object.freeFormReports) ? Boolean(object.freeFormReports) : undefined,
            communityIcon: isSet(object.communityIcon) ? String(object.communityIcon) : undefined,
            showMedia: isSet(object.showMedia) ? Boolean(object.showMedia) : undefined,
            iconColor: isSet(object.iconColor) ? String(object.iconColor) : undefined,
            displayName: isSet(object.displayName) ? String(object.displayName) : undefined,
            headerImg: isSet(object.headerImg) ? String(object.headerImg) : undefined,
            title: isSet(object.title) ? String(object.title) : undefined,
            coins: isSet(object.coins) ? Number(object.coins) : undefined,
            previousNames: globalThis.Array.isArray(object?.previousNames)
                ? object.previousNames.map((e) => String(e))
                : [],
            over18: isSet(object.over18) ? Boolean(object.over18) : undefined,
            iconSize: globalThis.Array.isArray(object?.iconSize) ? object.iconSize.map((e) => Number(e)) : [],
            primaryColor: isSet(object.primaryColor) ? String(object.primaryColor) : undefined,
            iconImg: isSet(object.iconImg) ? String(object.iconImg) : undefined,
            description: isSet(object.description) ? String(object.description) : undefined,
            submitLinkLabel: isSet(object.submitLinkLabel) ? String(object.submitLinkLabel) : undefined,
            headerSize: isSet(object.headerSize) ? String(object.headerSize) : undefined,
            restrictCommenting: isSet(object.restrictCommenting) ? Boolean(object.restrictCommenting) : undefined,
            subscribers: isSet(object.subscribers) ? Number(object.subscribers) : undefined,
            submitTextLabel: isSet(object.submitTextLabel) ? String(object.submitTextLabel) : undefined,
            isDefaultIcon: isSet(object.isDefaultIcon) ? Boolean(object.isDefaultIcon) : undefined,
            linkFlairPosition: isSet(object.linkFlairPosition) ? String(object.linkFlairPosition) : undefined,
            displayNamePrefixed: isSet(object.displayNamePrefixed) ? String(object.displayNamePrefixed) : undefined,
            keyColor: isSet(object.keyColor) ? String(object.keyColor) : undefined,
            name: isSet(object.name) ? String(object.name) : undefined,
            isDefaultBanner: isSet(object.isDefaultBanner) ? Boolean(object.isDefaultBanner) : undefined,
            url: isSet(object.url) ? String(object.url) : undefined,
            quarantine: isSet(object.quarantine) ? Boolean(object.quarantine) : undefined,
            bannerSize: globalThis.Array.isArray(object?.bannerSize) ? object.bannerSize.map((e) => Number(e)) : [],
            userIsModerator: isSet(object.userIsModerator) ? Boolean(object.userIsModerator) : undefined,
            acceptFollowers: isSet(object.acceptFollowers) ? Boolean(object.acceptFollowers) : undefined,
            publicDescription: isSet(object.publicDescription) ? String(object.publicDescription) : undefined,
            linkFlairEnabled: isSet(object.linkFlairEnabled) ? Boolean(object.linkFlairEnabled) : undefined,
            disableContributorRequests: isSet(object.disableContributorRequests)
                ? Boolean(object.disableContributorRequests)
                : undefined,
            subredditType: isSet(object.subredditType) ? String(object.subredditType) : undefined,
            userIsSubscriber: isSet(object.userIsSubscriber) ? Boolean(object.userIsSubscriber) : undefined,
            publicDescriptionHtml: isSet(object.publicDescriptionHtml) ? String(object.publicDescriptionHtml) : undefined,
            id: isSet(object.id) ? String(object.id) : undefined,
            userIsMuted: isSet(object.userIsMuted) ? globalThis.Boolean(object.userIsMuted) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.defaultSet !== undefined) {
            obj.defaultSet = message.defaultSet;
        }
        if (message.userIsContributor !== undefined) {
            obj.userIsContributor = message.userIsContributor;
        }
        if (message.bannerImg !== undefined) {
            obj.bannerImg = message.bannerImg;
        }
        if (message.restrictPosting !== undefined) {
            obj.restrictPosting = message.restrictPosting;
        }
        if (message.userIsBanned !== undefined) {
            obj.userIsBanned = message.userIsBanned;
        }
        if (message.freeFormReports !== undefined) {
            obj.freeFormReports = message.freeFormReports;
        }
        if (message.communityIcon !== undefined) {
            obj.communityIcon = message.communityIcon;
        }
        if (message.showMedia !== undefined) {
            obj.showMedia = message.showMedia;
        }
        if (message.iconColor !== undefined) {
            obj.iconColor = message.iconColor;
        }
        if (message.displayName !== undefined) {
            obj.displayName = message.displayName;
        }
        if (message.headerImg !== undefined) {
            obj.headerImg = message.headerImg;
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.coins !== undefined) {
            obj.coins = message.coins;
        }
        if (message.previousNames?.length) {
            obj.previousNames = message.previousNames;
        }
        if (message.over18 !== undefined) {
            obj.over18 = message.over18;
        }
        if (message.iconSize?.length) {
            obj.iconSize = message.iconSize;
        }
        if (message.primaryColor !== undefined) {
            obj.primaryColor = message.primaryColor;
        }
        if (message.iconImg !== undefined) {
            obj.iconImg = message.iconImg;
        }
        if (message.description !== undefined) {
            obj.description = message.description;
        }
        if (message.submitLinkLabel !== undefined) {
            obj.submitLinkLabel = message.submitLinkLabel;
        }
        if (message.headerSize !== undefined) {
            obj.headerSize = message.headerSize;
        }
        if (message.restrictCommenting !== undefined) {
            obj.restrictCommenting = message.restrictCommenting;
        }
        if (message.subscribers !== undefined) {
            obj.subscribers = message.subscribers;
        }
        if (message.submitTextLabel !== undefined) {
            obj.submitTextLabel = message.submitTextLabel;
        }
        if (message.isDefaultIcon !== undefined) {
            obj.isDefaultIcon = message.isDefaultIcon;
        }
        if (message.linkFlairPosition !== undefined) {
            obj.linkFlairPosition = message.linkFlairPosition;
        }
        if (message.displayNamePrefixed !== undefined) {
            obj.displayNamePrefixed = message.displayNamePrefixed;
        }
        if (message.keyColor !== undefined) {
            obj.keyColor = message.keyColor;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.isDefaultBanner !== undefined) {
            obj.isDefaultBanner = message.isDefaultBanner;
        }
        if (message.url !== undefined) {
            obj.url = message.url;
        }
        if (message.quarantine !== undefined) {
            obj.quarantine = message.quarantine;
        }
        if (message.bannerSize?.length) {
            obj.bannerSize = message.bannerSize;
        }
        if (message.userIsModerator !== undefined) {
            obj.userIsModerator = message.userIsModerator;
        }
        if (message.acceptFollowers !== undefined) {
            obj.acceptFollowers = message.acceptFollowers;
        }
        if (message.publicDescription !== undefined) {
            obj.publicDescription = message.publicDescription;
        }
        if (message.linkFlairEnabled !== undefined) {
            obj.linkFlairEnabled = message.linkFlairEnabled;
        }
        if (message.disableContributorRequests !== undefined) {
            obj.disableContributorRequests = message.disableContributorRequests;
        }
        if (message.subredditType !== undefined) {
            obj.subredditType = message.subredditType;
        }
        if (message.userIsSubscriber !== undefined) {
            obj.userIsSubscriber = message.userIsSubscriber;
        }
        if (message.publicDescriptionHtml !== undefined) {
            obj.publicDescriptionHtml = message.publicDescriptionHtml;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.userIsMuted !== false) {
            obj.userIsMuted = message.userIsMuted;
        }
        return obj;
    },
    create(base) {
        return SubredditObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubredditObject();
        message.defaultSet = object.defaultSet ?? undefined;
        message.userIsContributor = object.userIsContributor ?? undefined;
        message.bannerImg = object.bannerImg ?? undefined;
        message.restrictPosting = object.restrictPosting ?? undefined;
        message.userIsBanned = object.userIsBanned ?? undefined;
        message.freeFormReports = object.freeFormReports ?? undefined;
        message.communityIcon = object.communityIcon ?? undefined;
        message.showMedia = object.showMedia ?? undefined;
        message.iconColor = object.iconColor ?? undefined;
        message.displayName = object.displayName ?? undefined;
        message.headerImg = object.headerImg ?? undefined;
        message.title = object.title ?? undefined;
        message.coins = object.coins ?? undefined;
        message.previousNames = object.previousNames?.map((e) => e) || [];
        message.over18 = object.over18 ?? undefined;
        message.iconSize = object.iconSize?.map((e) => e) || [];
        message.primaryColor = object.primaryColor ?? undefined;
        message.iconImg = object.iconImg ?? undefined;
        message.description = object.description ?? undefined;
        message.submitLinkLabel = object.submitLinkLabel ?? undefined;
        message.headerSize = object.headerSize ?? undefined;
        message.restrictCommenting = object.restrictCommenting ?? undefined;
        message.subscribers = object.subscribers ?? undefined;
        message.submitTextLabel = object.submitTextLabel ?? undefined;
        message.isDefaultIcon = object.isDefaultIcon ?? undefined;
        message.linkFlairPosition = object.linkFlairPosition ?? undefined;
        message.displayNamePrefixed = object.displayNamePrefixed ?? undefined;
        message.keyColor = object.keyColor ?? undefined;
        message.name = object.name ?? undefined;
        message.isDefaultBanner = object.isDefaultBanner ?? undefined;
        message.url = object.url ?? undefined;
        message.quarantine = object.quarantine ?? undefined;
        message.bannerSize = object.bannerSize?.map((e) => e) || [];
        message.userIsModerator = object.userIsModerator ?? undefined;
        message.acceptFollowers = object.acceptFollowers ?? undefined;
        message.publicDescription = object.publicDescription ?? undefined;
        message.linkFlairEnabled = object.linkFlairEnabled ?? undefined;
        message.disableContributorRequests = object.disableContributorRequests ?? undefined;
        message.subredditType = object.subredditType ?? undefined;
        message.userIsSubscriber = object.userIsSubscriber ?? undefined;
        message.publicDescriptionHtml = object.publicDescriptionHtml ?? undefined;
        message.id = object.id ?? undefined;
        message.userIsMuted = object.userIsMuted ?? false;
        return message;
    },
};
messageTypeRegistry.set(SubredditObject.$type, SubredditObject);
function createBaseJsonStatus() {
    return { json: undefined };
}
export const JsonStatus = {
    $type: "devvit.plugin.redditapi.common.JsonStatus",
    encode(message, writer = _m0.Writer.create()) {
        if (message.json !== undefined) {
            JsonStatus_JsonErrorType.encode(message.json, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJsonStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.json = JsonStatus_JsonErrorType.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { json: isSet(object.json) ? JsonStatus_JsonErrorType.fromJSON(object.json) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.json !== undefined) {
            obj.json = JsonStatus_JsonErrorType.toJSON(message.json);
        }
        return obj;
    },
    create(base) {
        return JsonStatus.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJsonStatus();
        message.json = (object.json !== undefined && object.json !== null)
            ? JsonStatus_JsonErrorType.fromPartial(object.json)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(JsonStatus.$type, JsonStatus);
function createBaseJsonStatus_JsonErrorType() {
    return { errors: [] };
}
export const JsonStatus_JsonErrorType = {
    $type: "devvit.plugin.redditapi.common.JsonStatus.JsonErrorType",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.errors) {
            StringValue.encode({ value: v }, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseJsonStatus_JsonErrorType();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.errors.push(StringValue.decode(reader, reader.uint32()).value);
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e) => String(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.errors?.length) {
            obj.errors = message.errors;
        }
        return obj;
    },
    create(base) {
        return JsonStatus_JsonErrorType.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseJsonStatus_JsonErrorType();
        message.errors = object.errors?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(JsonStatus_JsonErrorType.$type, JsonStatus_JsonErrorType);
function createBaseWrappedUserObject() {
    return { id: undefined, data: undefined };
}
export const WrappedUserObject = {
    $type: "devvit.plugin.redditapi.common.WrappedUserObject",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== undefined) {
            StringValue.encode({ value: message.id }, writer.uint32(10).fork()).ldelim();
        }
        if (message.data !== undefined) {
            User.encode(message.data, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWrappedUserObject();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.data = User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? String(object.id) : undefined,
            data: isSet(object.data) ? User.fromJSON(object.data) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.data !== undefined) {
            obj.data = User.toJSON(message.data);
        }
        return obj;
    },
    create(base) {
        return WrappedUserObject.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWrappedUserObject();
        message.id = object.id ?? undefined;
        message.data = (object.data !== undefined && object.data !== null) ? User.fromPartial(object.data) : undefined;
        return message;
    },
};
messageTypeRegistry.set(WrappedUserObject.$type, WrappedUserObject);
function createBaseApiClientConfig() {
    return {
        method: "",
        path: "",
        requestBodyType: 0,
        enforceJson: false,
        requestKindValue: "",
        validateContentIdContext: "",
        validateSubredditContext: "",
        useCustomResponseParser: false,
        runAsUserScopes: [],
        alwaysRunAsUser: false,
        validateWithoutEnforcement: false,
    };
}
export const ApiClientConfig = {
    $type: "devvit.plugin.redditapi.common.ApiClientConfig",
    encode(message, writer = _m0.Writer.create()) {
        if (message.method !== "") {
            writer.uint32(10).string(message.method);
        }
        if (message.path !== "") {
            writer.uint32(18).string(message.path);
        }
        if (message.requestBodyType !== 0) {
            writer.uint32(24).int32(message.requestBodyType);
        }
        if (message.enforceJson !== false) {
            writer.uint32(32).bool(message.enforceJson);
        }
        if (message.requestKindValue !== "") {
            writer.uint32(42).string(message.requestKindValue);
        }
        if (message.validateContentIdContext !== "") {
            writer.uint32(50).string(message.validateContentIdContext);
        }
        if (message.validateSubredditContext !== "") {
            writer.uint32(58).string(message.validateSubredditContext);
        }
        if (message.useCustomResponseParser !== false) {
            writer.uint32(64).bool(message.useCustomResponseParser);
        }
        writer.uint32(74).fork();
        for (const v of message.runAsUserScopes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.alwaysRunAsUser !== false) {
            writer.uint32(80).bool(message.alwaysRunAsUser);
        }
        if (message.validateWithoutEnforcement !== false) {
            writer.uint32(88).bool(message.validateWithoutEnforcement);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApiClientConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.method = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.path = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.requestBodyType = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.enforceJson = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.requestKindValue = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.validateContentIdContext = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.validateSubredditContext = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.useCustomResponseParser = reader.bool();
                    continue;
                case 9:
                    if (tag === 72) {
                        message.runAsUserScopes.push(reader.int32());
                        continue;
                    }
                    if (tag === 74) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.runAsUserScopes.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.alwaysRunAsUser = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.validateWithoutEnforcement = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            method: isSet(object.method) ? globalThis.String(object.method) : "",
            path: isSet(object.path) ? globalThis.String(object.path) : "",
            requestBodyType: isSet(object.requestBodyType) ? apiClientConfig_BodyTypeFromJSON(object.requestBodyType) : 0,
            enforceJson: isSet(object.enforceJson) ? globalThis.Boolean(object.enforceJson) : false,
            requestKindValue: isSet(object.requestKindValue) ? globalThis.String(object.requestKindValue) : "",
            validateContentIdContext: isSet(object.validateContentIdContext)
                ? globalThis.String(object.validateContentIdContext)
                : "",
            validateSubredditContext: isSet(object.validateSubredditContext)
                ? globalThis.String(object.validateSubredditContext)
                : "",
            useCustomResponseParser: isSet(object.useCustomResponseParser)
                ? globalThis.Boolean(object.useCustomResponseParser)
                : false,
            runAsUserScopes: globalThis.Array.isArray(object?.runAsUserScopes)
                ? object.runAsUserScopes.map((e) => scopeFromJSON(e))
                : [],
            alwaysRunAsUser: isSet(object.alwaysRunAsUser) ? globalThis.Boolean(object.alwaysRunAsUser) : false,
            validateWithoutEnforcement: isSet(object.validateWithoutEnforcement)
                ? globalThis.Boolean(object.validateWithoutEnforcement)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.method !== "") {
            obj.method = message.method;
        }
        if (message.path !== "") {
            obj.path = message.path;
        }
        if (message.requestBodyType !== 0) {
            obj.requestBodyType = apiClientConfig_BodyTypeToJSON(message.requestBodyType);
        }
        if (message.enforceJson !== false) {
            obj.enforceJson = message.enforceJson;
        }
        if (message.requestKindValue !== "") {
            obj.requestKindValue = message.requestKindValue;
        }
        if (message.validateContentIdContext !== "") {
            obj.validateContentIdContext = message.validateContentIdContext;
        }
        if (message.validateSubredditContext !== "") {
            obj.validateSubredditContext = message.validateSubredditContext;
        }
        if (message.useCustomResponseParser !== false) {
            obj.useCustomResponseParser = message.useCustomResponseParser;
        }
        if (message.runAsUserScopes?.length) {
            obj.runAsUserScopes = message.runAsUserScopes.map((e) => scopeToJSON(e));
        }
        if (message.alwaysRunAsUser !== false) {
            obj.alwaysRunAsUser = message.alwaysRunAsUser;
        }
        if (message.validateWithoutEnforcement !== false) {
            obj.validateWithoutEnforcement = message.validateWithoutEnforcement;
        }
        return obj;
    },
    create(base) {
        return ApiClientConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApiClientConfig();
        message.method = object.method ?? "";
        message.path = object.path ?? "";
        message.requestBodyType = object.requestBodyType ?? 0;
        message.enforceJson = object.enforceJson ?? false;
        message.requestKindValue = object.requestKindValue ?? "";
        message.validateContentIdContext = object.validateContentIdContext ?? "";
        message.validateSubredditContext = object.validateSubredditContext ?? "";
        message.useCustomResponseParser = object.useCustomResponseParser ?? false;
        message.runAsUserScopes = object.runAsUserScopes?.map((e) => e) || [];
        message.alwaysRunAsUser = object.alwaysRunAsUser ?? false;
        message.validateWithoutEnforcement = object.validateWithoutEnforcement ?? false;
        return message;
    },
};
messageTypeRegistry.set(ApiClientConfig.$type, ApiClientConfig);
function createBaseUserGeneratedContent() {
    return { text: "", imageUrls: [] };
}
export const UserGeneratedContent = {
    $type: "devvit.plugin.redditapi.common.UserGeneratedContent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        for (const v of message.imageUrls) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserGeneratedContent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.imageUrls.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            imageUrls: globalThis.Array.isArray(object?.imageUrls)
                ? object.imageUrls.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.imageUrls?.length) {
            obj.imageUrls = message.imageUrls;
        }
        return obj;
    },
    create(base) {
        return UserGeneratedContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserGeneratedContent();
        message.text = object.text ?? "";
        message.imageUrls = object.imageUrls?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(UserGeneratedContent.$type, UserGeneratedContent);
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
